<template>
  <div>
    <!-- <b-modal v-model="isShowModal.editTemplateName" title="Edit Template Name" hide-footer> -->
    <el-dialog top="10vh" title="Edit Template Name" @close="isShowModal.editTemplateName = false" :visible.sync="isShowModal.editTemplateName" :close-on-press-escape="false" :close-on-click-modal="false">
      <b-form @submit.prevent="onSubmitEditTemplateName" @reset="closeModalEditTemplate">
        <el-input
          type="text"
          placeholder="Input your message template name"
          v-model="temp.template_name"
          ref="inputEditTemplateName"
          @keydown.native="handlerInputTemplateName($event, 'edit_template_name')"
          @keyup.native="handlerInputTemplateName($event, 'edit_template_name')"
          maxlength="512"
          show-word-limit
        />
        <div class="d-flex flex-row-reverse mt-2">
          <el-button @click="submitChangeTemplateName" :disabled="!temp.template_name" size="small" type="primary" class="ml-2">{{ $t('general.done') }}</el-button>
          <el-button @click="isShowModal.editTemplateName = false" size="small" type="secondary">{{ $t('general.cancel') }}</el-button>
        </div>
      </b-form>
    </el-dialog>
    <!-- </b-modal> -->
    <!-- <b-modal v-model="isShowModal.addSample" title="Add Sample Content" hide-footer> -->
    <el-dialog top="10vh" title="Add Sample Content" @close="isShowModal.addSample = false" :visible.sync="isShowModal.addSample" :close-on-press-escape="false" :close-on-click-modal="false">
      <p>
        To help us understand what kind of message you want to send, you have the option to provide specific content examples for your template. You can add a sample template for one or all languages you are submitting. Make sure not to include any actual user or customer information, and provide only sample content in your examples.
      </p>
      <hr/>
      <div v-if="headerHasParamOrMedia">
        <h6 class="text-capitalize">Header</h6>
        <el-input v-if="example_template.header.type == 'text'" class="mt-1" size="small" v-model="example_template.header.example.data" :placeholder="'Input content for {{1}}'" />
        <b-file v-loading="loading.upload_sample_media" class="mt-2" v-else-if="example_template.header.content && example_template.header.type == 'media'" :accept="whiteListExtensionHeaderMedia[example_template.header.content].join(',')" @input="handlerFileHeaderMedia" v-model="example_template.header.file"/>
        <hr/>
      </div>
      <div v-if="bodyHasParam">
        <h6 class="text-capitalize">Body</h6>
        <div v-if="example_template.body.examples.length > 0">
          <span v-for="(item, i) in example_template.body.examples" :key="i">
            <el-input class="mt-1" size="small" v-model="example_template.body.examples[i].text" :placeholder="`Input content for ` + item.replacement"/>
          </span>
        </div>
        <hr/>
      </div>
      <div v-if="buttonHasDynamic && example_template.buttons.content.length">
        <h6 class="text-capitalize">Buttons</h6>
        <span v-for="(item, i) in example_template.buttons.content" :key="i">
          <el-input
            size="small"
            class="mt-1"
            type="text"
            v-model="example_template.buttons.examples[i]"
            v-if="item.type == 'url' && item.url_type == 'dynamic'"
            :placeholder="`Input full URL for ` + item.url" />
        </span>
      </div>
      <div class="d-flex flex-row-reverse mt-4">
        <el-button @click="submitExample" :disabled="isInvalidExample" type="primary" size="small" class="ml-2">{{ $t('general.done') }}</el-button>
        <el-button @click="isShowModal.addSample = false" size="small" plain>{{ $t('general.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- </b-modal> -->
    <!-- Modal Carousel -->
    <PreviewCarousel
      :show="isShowModal.carouselCard"
      :active_template_show="active_template.carousel[active_card]"
      :language_str="active_template.language_str"
      :card_index="active_card"
      @onHide="isShowModal.carouselCard = false"
    />
    <b-card-body v-if="step === 1">
      <b-card-title class="text-capitalize">Name</b-card-title>
      <b-card-sub-title class="mb-4">
        Give your message template a name.
      </b-card-sub-title>
      <b-row>
        <b-col>
          <el-input
            type="text"
            placeholder="Input your message template name"
            v-model="form1.template_name"
            maxlength="512"
            @keydown.native="handlerInputTemplateName($event, 'create_template_name')"
            @keyup.native="handlerInputTemplateName($event, 'create_template_name')"
            show-word-limit
          />
        </b-col>
      </b-row>
      <hr/>
      <b-card-title class="text-capitalize">Divisions</b-card-title>
      <b-card-sub-title class="mb-4">
        Choose which divisions are eligible to use the template.
      </b-card-sub-title>
      <b-row>
        <b-col>
          <el-select v-model="temp.groups_id" filterable multiple placeholder="Select divisions" class="w-100">
            <el-option
              v-for="item in division_list"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </b-col>
      </b-row>
      <hr/>
      <div class="d-flex float-right mb-4">
        <el-button @click="nextStep(step)" :disabled="!isValidStep1" size="small" type="primary">Continue</el-button>
        <el-button @click="backToList()" type="default" size="small">Back</el-button>
      </div>
    </b-card-body>
    <b-card-body style="height: 725px;" v-if="step === 2">
      <div class="inline inline-flex justify-between-content">
        <b-row>
          <b-col md=6>
            <h5 class="text-lowercase">{{ form1.template_name }}&nbsp;&nbsp;<a @click="showModalEditTemplateName" class="cursor-pointer"><font-awesome icon="pen"/></a></h5>
          </b-col>
          <b-col md=6 class="float-right">
            <el-button type="primary" :disabled="checkComplete()" :loading="loading.submit" @click="submitTemplate" size="small" class="float-right ml-2">Submit</el-button>
            <el-button size="small" plain @click="backToList()" type="default" class="float-right text-primary">Cancel</el-button>
            <el-button @click="backToStep(step - 1)" type="default" size="small" class="float-right text-primary">Back</el-button>
          </b-col>
        </b-row>
      </div>
      <hr/>
      <b-row>
        <b-col md=3>
          <!-- <div class="d-flex w-100" style="height: 100%;"> -->
          <div class="d-flex w-100" style="height: 100%; max-height: 80%; overflow: hidden;">
            <div style="height: 100%; border-right: 1px solid #d8d8d8;">
                <el-tooltip
                  v-for="(panel, idx_panels) in panels"
                  :key="idx_panels"
                  :content="panel.name"
                  placement="right"
                  popper-class="fit-tooltip"
                  class="mt-2"
                >
                  <i
                    v-if="panel.name === 'Settings' ? Object.values(selectedElement).length && selectedElement.category !== 'font' : true"
                    :id="panel.name"
                    :class="[
                      'icon-wrapper mr-3',
                      'mdi',
                      `mdi-${panel.icon}`,
                      'mdi-36px',
                      { 'icon-panel-selected': selectedPanel.name === panel.name }
                    ]"
                    @click="selectedPanel = panel"
                  ></i>
                </el-tooltip>
              </div>
              <div v-if="Object.values(selectedPanel).length" :class="['panel-elements', 'ml-4']">
                <div class="pr-3 fixed-panel" v-if="selectedPanel.name === 'Elements'">
                  <div>
                    <div class="mt-2">
                      <div class="d-flex">
                        <el-tooltip class="item" effect="dark" content="Font" placement="top">
                          <div draggable @dragstart="startDrag($event, 'font')" class="subpanel-icon mr-3">
                             <Font :width="40" :height="40" />
                           </div>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="Image" placement="top">
                          <i draggable @dragstart="startDrag($event, 'image')" class="subpanel-icon mdi mdi-image-outline"></i>
                        </el-tooltip>
                      </div>
                      <div class="d-flex mt-3">
                        <el-tooltip class="item" effect="dark" content="Button" placement="top">
                           <div draggable @dragstart="startDrag($event, 'button')" class="subpanel-icon mr-3">
                             <CursorButton :width="40" :height="40" />
                           </div>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="Divider" placement="top">
                          <i draggable @dragstart="startDrag($event, 'divider')" class="subpanel-icon mdi mdi-border-horizontal"></i>
                        </el-tooltip>
                      </div>
                      <div class="d-flex mt-3">
                        <el-tooltip class="item" effect="dark" content="Spacer" placement="top">
                          <i draggable @dragstart="startDrag($event, 'spacer')" class="subpanel-icon mdi mdi-arrow-expand-vertical mr-3"></i>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="panel-layout" v-else-if="selectedPanel.name === 'Layout'">
                  <div class="scroll-wrapper">
                    <p>1 Column</p>
                    <div class="panel-column mb-3">
                      <div @dragstart="startDrag($event, 'column1', '12')" draggable class="sub-panel-column">
                        <div class="inner-panel-column"></div>
                      </div>
                    </div>
                    <p>2 Column</p>
                    <div class="panel-column mb-3">
                      <div @dragstart="startDrag($event, 'column2', '6,6')" draggable class="sub-panel-column d-flex">
                        <div class="inner-panel-column mr-2"></div>
                        <div class="inner-panel-column"></div>
                      </div>
                    </div>
                    <div class="panel-column mb-3">
                      <div @dragstart="startDrag($event, 'column2', '2,10')" draggable class="sub-panel-column d-flex">
                        <div style="width: 20% !important;" class="inner-panel-column w-20 mr-2"></div>
                        <div class="inner-panel-column"></div>
                      </div>
                    </div>
                    <div class="panel-column mb-3">
                      <div @dragstart="startDrag($event, 'column2', '4,8')" draggable class="sub-panel-column d-flex">
                        <div style="width: 40% !important;" class="inner-panel-column mr-2"></div>
                        <div class="inner-panel-column"></div>
                      </div>
                    </div>
                    <div class="panel-column mb-3">
                      <div @dragstart="startDrag($event, 'column2', '8,4')" draggable class="sub-panel-column d-flex">
                        <div class="inner-panel-column mr-2"></div>
                        <div style="width: 40% !important" class="inner-panel-column"></div>
                      </div>
                    </div>
                    <div class="panel-column mb-3">
                      <div @dragstart="startDrag($event, 'column2', '10,2')" draggable class="sub-panel-column d-flex">
                        <div class="inner-panel-column mr-2"></div>
                        <div style="width: 20% !important" class="inner-panel-column"></div>
                      </div>
                    </div>
                    <p>3 Column</p>
                    <div class="panel-column mb-3">
                      <div @dragstart="startDrag($event, 'column3', '4,4,4')" draggable class="sub-panel-column d-flex">
                        <div class="inner-panel-column mr-2"></div>
                        <div class="inner-panel-column mr-2"></div>
                        <div class="inner-panel-column"></div>
                      </div>
                    </div>
                    <div class="panel-column mb-3">
                      <div @dragstart="startDrag($event, 'column3', '2,2,8')" draggable class="sub-panel-column d-flex">
                        <div style="width: 20% !important" class="inner-panel-column mr-2"></div>
                        <div style="width: 20% !important" class="inner-panel-column mr-2"></div>
                        <div class="inner-panel-column"></div>
                      </div>
                    </div>
                    <div class="panel-column mb-3">
                      <div @dragstart="startDrag($event, 'column3', '2,8,2')" draggable class="sub-panel-column d-flex">
                        <div style="width: 20% !important" class="inner-panel-column mr-2"></div>
                        <div class="inner-panel-column mr-2"></div>
                        <div style="width: 20% !important" class="inner-panel-column"></div>
                      </div>
                    </div>
                    <div class="panel-column mb-3">
                      <div @dragstart="startDrag($event, 'column3', '8,2,2')" draggable class="sub-panel-column d-flex">
                        <div class="inner-panel-column mr-2"></div>
                        <div style="width: 20% !important" class="inner-panel-column mr-2"></div>
                        <div style="width: 20% !important" class="inner-panel-column"></div>
                      </div>
                    </div>
                    <p>4 Column</p>
                    <div class="panel-column mb-3">
                      <div @dragstart="startDrag($event, 'column4', '3,3,3,3')" draggable class="sub-panel-column d-flex">
                        <div class="inner-panel-column mr-2"></div>
                        <div class="inner-panel-column mr-2"></div>
                        <div class="inner-panel-column mr-2"></div>
                        <div class="inner-panel-column"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="panel-layout" v-else-if="selectedPanel.name === 'Settings'">
                  <template v-if="selectedElement.category === 'button'">
                    <div class="mb-2">
                      <p>Container Style</p>
                      <el-radio-group class="mt-2" v-model="selectedElement.container_style" @change="onChangeSettings">
                        <el-radio label="boxed">Boxed</el-radio>
                        <el-radio label="full_width">Full Width</el-radio>
                    </el-radio-group>
                    </div>
                    <p class="mb-2">Positioning</p>
                    <div class="d-flex mb-2">
                      <div
                        v-for="(item, idx_item) in ['left', 'center', 'end']"
                        :key="idx_item"
                        :style="{
                          height: '55px',
                          width: '55px',
                          backgroundColor: selectedElement.align === item ? '##e6f4f2' : '#fafafa',
                          color: selectedElement.align === item ? '#118c7f' : '#7f7f7f',
                        }"
                        :class="[
                          'd-flex',
                          'justify-content-center',
                          'align-items-center',
                          'text-center',
                          { 'ml-1': idx_item > 0 },
                        ]"
                        class="cursor-pointer rounded"
                        @click="() => {
                          selectedElement.align = item;
                          onChangeSettings();
                        }"
                      >
                        <i
                          style="font-size: 25px"
                          :class="['mdi', `mdi-format-align-${item === 'end' ? 'right' : item}`]"
                        />
                      </div>
                    </div>
                    <div class="mb-2">
                      <p>Background</p>
                      <el-radio-group
                        class="mt-2"
                        v-model="selectedElement.background"
                        @change="onChangeSettings"
                      >
                        <el-radio label="transparent">Transparent</el-radio>
                        <el-radio label="color">Color</el-radio>
                      </el-radio-group>
                    </div>
                    <div v-if="selectedElement.background === 'color'">
                      <p class="mt-3 mb-2 demonstration">With default value</p>
                      <div class="d-flex align-items-center">
                        <el-color-picker
                          v-model="selectedElement.color"
                          @change="onChangeSettings"
                          color-format="hex"
                        />
                        <span class="ml-2">
                          {{ selectedElement.color }}
                        </span>
                      </div>
                    </div>
                    <p class="mb-2 mt-2">Radius</p>
                    <el-input
                        type="number"
                        class="w-100"
                        v-model.number="selectedElement.radius"
                        min="1"
                        max="100"
                        @input="onChangeSettings"
                    />
                  </template>
                  <template v-if="selectedElement.category === 'divider'">
                    <p class="mb-2">Weight</p>
                    <el-input
                      class="mb-2"
                      type="number"
                      v-model.number="selectedElement.weight"
                      min="1"
                      @change="onChangeSettings"
                    />
                    <p class="mb-2">Width (%)</p>
                    <el-input
                      class="mb-2"
                      type="number"
                      v-model.number="selectedElement.width"
                      min="1"
                      max="100"
                      @change="onChangeSettings"
                    />
                    <p class="mb-2">Style</p>
                    <div class="d-flex mb-2">
                      <div
                        v-for="(item, idx_item) in ['solid', 'dashed', 'dotted', 'double']"
                        :key="idx_item"
                        :style="{
                          height: '50px',
                          width: '50px',
                          backgroundColor: selectedElement.style === item ? '#e6f4f2' : '#fafafa',
                          color: selectedElement.style === item ? '#118c7f' : '#7f7f7f',
                        }"
                        :class="[
                          'd-flex',
                          'p-2',
                          'justify-content-center',
                          'align-items-center',
                          'text-center',
                          { 'ml-1': idx_item > 0 },
                        ]"
                        class="cursor-pointer rounded"
                        @click="() => {
                          selectedElement.style = item;
                          onChangeSettings();
                        }"
                      >
                        <div :style="{
                          padding: '1px',
                          width: '100%',
                          borderBottom: `2px ${item} black`
                        }"></div>
                      </div>
                    </div>
                    <div>
                      <p class="mt-3 mb-2 demonstration">Color</p>
                      <div class="d-flex align-items-center">
                        <el-color-picker
                          v-model="selectedElement.color"
                          @change="onChangeSettings"
                          color-format="hex"
                        />
                        <span class="ml-2" :style="{ color: selectedElement.color }">
                          {{ selectedElement.color }}
                        </span>
                      </div>
                    </div>
                  </template>
                  <template v-if="selectedElement.category === 'image'">
                    <div class="mb-2">
                      <p class="mb-2">Width</p>
                      <el-input
                        type="number"
                        class="w-100"
                        v-model.number="selectedElement.width"
                        min="1"
                        :max="selectedElement.max_size"
                        @input="onInputMaxSizeImage('width')"
                      />
                    </div>
                    <div class="mb-2">
                      <p class="mb-2">Height</p>
                      <el-input
                        class="w-100"
                        type="number"
                        v-model.number="selectedElement.height"
                        min="1"
                        :max="selectedElement.max_size"
                        @input="onInputMaxSizeImage('height')"
                      />
                    </div>
                    <!-- <div class="d-flex mb-3">
                    </div> -->
                    <p class="mb-2">Positioning</p>
                    <div class="d-flex">
                      <div
                        v-for="(item, idx_item) in ['left', 'center', 'end']"
                        :key="idx_item"
                        :style="{
                          height: '50px',
                          width: '50px',
                          backgroundColor: selectedElement.align === item ? '##e6f4f2' : '#fafafa',
                          color: selectedElement.align === item ? '#118c7f' : '#7f7f7f',
                        }"
                        :class="[
                          'd-flex',
                          'justify-content-center',
                          'align-items-center',
                          'text-center',
                          { 'ml-1': idx_item > 0 },
                        ]"
                        class="cursor-pointer rounded"
                        @click="() => {
                          selectedElement.align = item;
                          onChangeSettings();
                        }"
                      >
                        <i
                          style="font-size: 25px"
                          :class="['mdi', `mdi-format-align-${item === 'end' ? 'right' : item}`]"
                        />
                      </div>
                    </div>
                    <div class="mb-2 mt-2">
                      <p>Insert Link (URL)</p>
                      <el-checkbox v-model="selectedElement.insert_link" @change="onChangeSettings">Use Link</el-checkbox>
                    </div>
                  </template>
                  <template v-if="selectedElement.category === 'spacer'">
                    <div>
                        <p class="mb-2">Range (Top/Bottom)</p>
                        <el-input
                          type="number"
                          v-model.number="selectedElement.spacer"
                          min="1"
                          @change="onChangeSettings"
                        />
                      </div>
                  </template>
                </div>
              </div>
            </div>
        </b-col>
        <b-col class="p-3" style="background-color: #f8f9fa;"  md=9>
          <div class="bg-white p-3 inline inline-flex justify-between-content">
            <b-row>
              <b-col md=6>
                <h5>Message Content</h5>
              </b-col>
              <b-col md=6 class="float-right">
                <div class="d-flex float-right">
                  <div class="mr-2">
                    <el-button :disabled="!isNeedSample" @click="addSampleContent(active_template)" size="small" type="info" class="float-right ml-2">Add Sample</el-button>
                    <span v-if="active_template.body.content">
                      <span class="float-right" v-if="isCompleteSample"><font-awesome icon="circle" class="text-success"/>&nbsp;Good</span>
                      <span class="float-right" v-else><font-awesome :icon="['fas', 'circle']" class="text-danger"/>&nbsp;Incomplete sample</span>
                    </span>
                  </div>
                  <el-button
                    size="small"
                    class="text-primary"
                    @click="previewDetail"
                  >
                    <i class="mdi mdi-play-outline text-primary mr-1" />Preview
                  </el-button>
                </div>
              </b-col>
            </b-row>
          </div>
          <hr/>
          <template v-if="form1.category != 'authentication'">
            <div v-if="active_template.header.type !== 'carousel'">
              <div id="body-content">
                <div class="mb-5">
                  <dropping-item-email
                    :sortedMappingComponents="sortedMappingComponents"
                    :selectedElement="selectedElement"
                    @onDrop="onDrop"
                    @startDragOrderLayout="startDragOrderLayout" @onDropAdjustOrderLayout="onDropAdjustOrderLayout" @startDragOrderElement="startDragOrderElement" @onDropAdjustOrderElement="onDropAdjustOrderElement" @saveBoxElements="saveBoxElements" @editBoxElements="editBoxElements" @deleteBoxElements="deleteBoxElements" @deleteBoxLayout="deleteBoxLayout" @onChangeConvertHtmlElements="onChangeConvertHtmlElements" @handlerInputBodyContent="handlerInputBodyContent" @addVariableBody="addVariableBody"
                    @onSelectElement="onSelectElement"
                  />
                </div>
              </div>
            </div>
            <div v-else>
              <div class="card-content" v-for="(item_carousel, i) in active_template.carousel" :key="i">
                <div class="inline inline-flex justify-between-content">
                  <b-row>
                    <b-col md=3 @click="showCarouselCard(i)" class="cursor-pointer">
                        <h5 class="text-capitalize">Card {{ i+1 }} &nbsp;</h5>
                        <span>
                          <span class="float-left mt-1" v-if="isCompleteSampleCard(i)"><font-awesome icon="circle" class="text-success"/>&nbsp;Good</span>
                          <span class="float-left mt-1" v-else><font-awesome :icon="['fas', 'circle']" class="text-danger"/>&nbsp;Incomplete sample</span>
                        </span>
                    </b-col>
                    <b-col md=5 class="text-center">
                      <div class="header-media-area mb-2">
                        <span v-if="item_carousel.header.example.base64 && item_carousel.header.content === 'image'">
                          <div class="header-media-filled" :style="'background-image: url('+ item_carousel.header.example.base64 +')'"/>
                        </span>
                        <div v-else class="header-media-content" :style="'background-image: url('+ bg_media[item_carousel.header.content] +')'">
                        </div>
                      </div>
                    </b-col>
                    <b-col md=4 class="float-right">
                      <!-- <a class="cursor-pointer float-right ml-2"><font-awesome class="text-danger" style="font-size: 1em" icon="trash"/></a> -->
                      <el-button v-if="active_template.carousel.length > 1" @click="handlerRemoveCardContent(i)" size="small" type="warning" class="float-right ml-2 btn-danger"><font-awesome style="font-size: 1em" icon="trash"/></el-button>
                      <el-button @click="showCarouselCard(i)" size="small" type="warning" class="float-right ml-2 btn-primary"><font-awesome style="font-size: 1em" icon="edit"/></el-button>
                    </b-col>
                  </b-row>
                  <hr/>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div id="body-content">
              <div>
                <b-card-title class="text-capitalize">Code Delivery</b-card-title>
                <b-card-sub-title class="mb-2">Choose how customers send the code from WhatsApp to your app.</b-card-sub-title>
                <b-row>
                  <b-col sm="12" md="12" class="mb-2" v-for="(opt, iopt) in otp_delivery_options" :key="iopt">
                    <div class="list-group">
                      <a @click="handlerOtpTypeRadio(opt.value)" class="list-group-item list-group-item-action cursor-pointer" :class="{ active: opt.value == active_template.otp_delivery_type }">
                        {{ opt.title }}<br/>
                        <small>{{ opt.description }}</small>
                      </a>
                    </div>
                    <div v-if="active_template.otp_delivery_type == 'one_tap' && iopt === 0" class="card mt-2">
                      <div class="card-body">
                        <b-form-group label-cols-sm="4"
                          label-cols-lg="3"
                          content-cols-sm
                          content-cols-lg="8"
                          label="Package Name">
                          <b-input
                            type="text"
                            placeholder="Input package name. Example: com.example.myapplication"
                            v-model="active_template.otp_autofill_text"
                          />
                        </b-form-group>
                        <b-form-group label-cols-sm="4"
                          label-cols-lg="3"
                          content-cols-sm
                          content-cols-lg="8"
                          label="App signature hash">
                          <b-input
                            type="text"
                            placeholder="Input text"
                            v-model="active_template.otp_signature_hash"
                          />
                        </b-form-group>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>
            <hr/>
            <div id="body-content">
              <div>
                <b-card-title class="text-capitalize">Button text</b-card-title>
                <b-card-sub-title class="mb-2">You can customise the button text for both auto-fill and copy code. Even when zero-tap is turned on, buttons are still needed for the backup code delivery method.</b-card-sub-title>
                <div>
                  <b-form-group label-cols-sm="4"
                    label-cols-lg="3"
                    content-cols-sm
                    content-cols-lg="8"
                    label="Copy code">
                    <el-input
                      type="text"
                      size="small"
                      placeholder="Input button text"
                      v-model="active_template.buttons.content[0].text"
                      show-word-limit
                      maxlength="25"
                    />
                  </b-form-group>
                </div>
              </div>
            </div>
            <hr/>
            <div id="body-content">
              <div>
                <b-card-title class="text-capitalize">Message content</b-card-title>
                <b-card-sub-title class="mb-2">Content for authentication message templates can't be edited. You can add additional content from the options below.</b-card-sub-title>
                <div>
                  <el-checkbox @change="checkedSecurityChanged($event, active_template.language)" v-model="active_template.otp_add_security_wording">Add security recommendation</el-checkbox>
                </div>
                <div>
                  <el-checkbox @change="checkedExpiryChanged($event, active_template.language)" v-model="active_template.otp_add_expiry_wording">Add expiry time for the code</el-checkbox>
                  <b-form-group v-if="active_template.otp_add_expiry_wording" label-cols-sm="4"
                    label-cols-lg="3"
                    content-cols-sm
                    content-cols-lg="4"
                    label="Expires in">
                    <el-input
                      type="number"
                      size="small"
                      @change="handlerChangeOtpExpires"
                      placeholder="Input button text"
                      v-model="active_template.otp_expires_in"
                    >
                      <template slot="append">minutes</template>
                    </el-input>
                    </b-form-group>
                </div>
              </div>
            </div>
          </template>
        </b-col>
        <b-col class="d-none" md=4>
          <div class="screen">
            <div class="screen-container">
              <div class="chat">
                <div class="chat-container">
                  <div class="conversation">
                    <div class="conversation-container vh-100">
                      <h6 class="mt-2">Preview</h6>
                        <p class="preview-body" v-html="previewContent"/>
                      <Transition name="fade">
                        <div class="preview-button bottom w-100" v-if="isShowModal.allButton">
                          <span style="font-size: 14px; line-height: 1.75rem;">
                            All Options
                            <a @click="showAllButtons()" class="float-right cursor-pointer text-black" style="font-size: 14px;">
                              <font-awesome icon="times"/>
                            </a>
                          </span>
                          <div class="cta-area w-100" v-if="active_template.buttons.content.filter((v) => v.type !== 'quick_reply').length > 0">
                            <div class="cta-button" v-for="(item, i) in active_template.buttons.content.filter((v) => v.type !== 'quick_reply')" :key="i">
                              <p>
                                <font-awesome :icon="button_icons[item.type]"/>
                                &nbsp;{{ item.type === 'copy_code' ? 'Copy Coupon Code' : item.text }}
                              </p>
                            </div>
                          </div>
                          <div class="cta-area w-100" v-if="active_template.buttons.content.filter((v) => v.type === 'quick_reply').length > 0">
                            <div class="cta-button" v-for="(item, i) in active_template.buttons.content.filter((v) => v.type === 'quick_reply')" :key="i">
                              <p>
                                <font-awesome :icon="button_icons[item.type]"/>
                                &nbsp;{{ item.type === 'copy_code' ? 'Copy Coupon Code' : item.text }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </Transition>
                      <!-- carousel message -->
                      <!-- Swiper Carousel -->
                      <div v-if="active_template.header.type === 'carousel'">
                        <swiper
                          slides-per-view="1"
                          :scrollbar="{ draggable: true }"
                          :pagination="{
                            type: 'fraction',
                          }"
                          :spaceBetween="5"
                          mousewheel
                          freeMode
                          navigation
                        >
                          <swiper-slide v-for="(card, i) in 10" :key="i">
                            <div class="preview-message-carousel received" v-if="card <= active_template.carousel.length">
                              <div class="header-media-area mb-2">
                                <span v-if="active_template?.carousel[i]?.header.example.base64 && active_template?.carousel[i]?.header.content === 'image'">
                                  <div class="header-media-filled" :style="'background-image: url('+ active_template?.carousel[i]?.header.example.base64 +')'"/>
                                </span>
                                <div v-else class="header-media-content" :style="'background-image: url('+ bg_media[active_template?.carousel[i]?.header.content] +')'">
                                </div>
                              </div>
                              <p class="preview-body" v-html="previewContentCarousel(i)"/>
                              <p class="mt-2 preview-footer" v-if="previewFooterContentCarousel(i)">{{previewFooterContentCarousel(i)}}<br/></p>
                              <span class="metadata"><span class="time">{{ moment().format('HH:mm') }}</span></span>
                              <div class="cta-area w-100" v-if="active_template?.carousel[i]?.buttons.parent_type === 'call_to_action'">
                                <div class="cta-button" v-for="(item, x) in active_template?.carousel[i]?.buttons.content" :key="x">
                                  <p>
                                    <font-awesome :icon="button_icons[item.type]"/>
                                    &nbsp;{{ item.text }}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <!-- <div class="button-area w-100" style="margin-top: -1em" v-if="active_template?.carousel[i]?.buttons.parent_type === 'quick_reply'">
                              <div class="row-button">
                                <div class="col-button" v-for="(item, x) in active_template?.carousel[i]?.buttons.content" :key="x">
                                  {{ item.text }}
                                </div>
                              </div>
                            </div> -->
                          </swiper-slide>
                          <div class="swiper-scrollbar" slot="scrollbar"></div>
                          <div class="swiper-button-prev" slot="button-prev"></div>
                          <div class="swiper-button-next" slot="button-next"></div>
                        </swiper>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card-body>
  </div>
</template>
<script>
import moment from 'moment';
import {
  cloneDeep, isEmpty, escapeRegExp, uniq,
} from 'lodash';
import language from '@/library/language.json';
import country_code from '@/library/country_code.json';
import popupErrorMessages from '@/library/popup-error-messages';
import wa_auth_wording from '@/library/wa_auth_wording.json';
import { Scrollbar, Mousewheel, Navigation } from 'swiper';
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2';
import notifApi from '../../../api/notifications';
import base64File from '../../../library/base64File';
import divisions from '../../../api/divisions';
import PreviewCarousel from './Carousel.vue';
import flowsAPI from '../../../api/flows';

import 'swiper/swiper-bundle.css';
import CursorButton from '../icons/CursorButton.vue';
import Font from '../icons/Font.vue';
import DroppingItemEmail from '../DroppingItemEmail.vue';

SwiperCore.use([Scrollbar, Mousewheel, Navigation]);
export default {
  name: 'CreateEmailTemplate',
  components: {
    DroppingItemEmail,
    PreviewCarousel,
    Swiper,
    SwiperSlide,
    CursorButton,
    Font,
  },
  data() {
    return {
      moment,
      active_card: 0,
      step: 1,
      loading: {
        upload_sample_media: false,
        submit: false,
        get_flows: false,
      },
      isShowModal: {
        editTemplateName: false,
        addSample: false,
        carouselCard: false,
        allButton: false,
      },
      text_length: {
        url: 25,
        phone_number: 25,
        quick_reply: 20,
        copy_code: 15,
      },
      max_length: {
        all: 10,
        cta: 5,
      },
      button_icons: {
        quick_reply: 'reply',
        copy_code: 'copy',
        url: 'external-link-alt',
        otp: 'copy',
        phone_number: 'phone-alt',
        flow: 'edit',
      },
      temp: {
        selected_language: ['id'],
        template_name: '',
        groups_id: [],
      },
      template_category: {
        whatsapp: [
          {
            name: 'Marketing',
            key: 'marketing',
            icon: 'bullhorn',
            info: 'Send promotions or information about your products, services, or business.',
          },
          {
            name: 'Utility',
            key: 'utility',
            icon: 'bell',
            info: 'Send messages about an existing order or account.',
          },
          {
            name: 'Authentication',
            key: 'authentication',
            icon: 'key',
            info: 'Send codes to verify a transaction or login.',
          },
        ],
      },
      bg_media: {
        image: 'https://media.wappin.chat/template-header-image.png',
        document: 'https://media.wappin.chat/template-header-document.png',
        video: 'https://media.wappin.chat/template-header-video.png',
      },
      form1: {
        category: 'regular',
        template_name: '',
      },
      is_back_template: false,
      active_template: {
        body: {
          // content: '',
          data: [],
          content: '',
          examples: [],
        },
        header: {
          type: 'none',
          content: '',
          example: { data: '', base64: '' },
        },
        footer: {
          content: '',
          examples: [],
        },
        buttons: {
          parent_type: 'none',
          content: [],
          examples: [],
        },
        carousel: [
          {
            body: {
              content: '',
              examples: [],
            },
            header: {
              type: 'none',
              content: 'image',
              file: null,
              example: { data: '', base64: '' },
            },
            footer: {
              content: '',
              examples: [],
            },
            buttons: {
              parent_type: 'call_to_action',
              content: [{
                type: 'url',
                url_type: '',
                text: '',
                url: '',
                phone_number: undefined,
                country_code: undefined,
              }],
              examples: [],
            },
          },
        ],
      },
      example_template: {
        body: {
          content: '',
          data: [],
          examples: [],
        },
        header: {
          type: 'none',
          content: '',
          example: { data: '', base64: '' },
        },
        footer: {
          content: '',
          examples: [],
        },
        buttons: {
          parent_type: 'none',
          content: [],
          examples: [],
        },
      },
      template_form: [],
      otp_delivery_options: [
        // {
        //   title: 'Auto-fill',
        //   description: 'Recommended as the easiest option for your customers. The code is sent to your app when a customer taps the button. A copy code message will be sent when auto-fill isn\'t possible.',
        //   value: 'one_tap',
        // },
        {
          title: 'Copy Code',
          description: 'Basic authentication with quick setup. Your customers copy and paste the code into your app.',
          value: 'copy_code',
        },
      ],
      languages_list: language,
      header_category: [
        {
          type: 'none',
          label: 'None',
        },
        {
          type: 'text',
          label: 'Text',
        },
        {
          type: 'media',
          label: 'Media',
        },
        {
          type: 'carousel',
          label: 'Carousel',
        },
      ],
      header_media_type: [
        {
          type: 'image',
          label: 'Image',
          icon: 'image',
        },
        {
          type: 'video',
          label: 'Video',
          icon: 'video',
        },
        {
          type: 'document',
          label: 'Document',
          icon: 'file-alt',
        },
      ],
      footer_category: [
        {
          type: 'none',
          label: 'None',
          group: ['none'],
        },
        {
          type: 'call_to_action',
          label: 'Call To Action',
          group: ['url', 'phone_number', 'copy_code', 'flow'],
        },
        {
          type: 'quick_reply',
          label: 'Quick Reply',
          group: ['quick_reply'],
        },
      ],
      call_to_action_category: [
        {
          type: 'url',
          label: 'Visit Website',
          max_length: 2,
        },
        {
          type: 'phone_number',
          label: 'Call Phone Number',
          max_length: 1,
        },
        {
          type: 'copy_code',
          label: 'Copy Coupon Code',
          max_length: 1,
        },
        {
          type: 'flow',
          label: 'Flow',
          max_length: 1,
        },
      ],
      url_type: [
        {
          type: 'static',
          label: 'Static',
        },
        {
          type: 'dynamic',
          label: 'Dynamic',
        },
      ],
      country_code: country_code.map((v) => {
        v.label_str = `(${v.value}) ${v.label}`;
        return v;
      }),
      addMoreLanguage: '',
      whiteListExtensionHeaderMedia: {
        image: ['.jpg', '.png'],
        video: ['.mp4'],
        document: ['.pdf'],
      },
      division_list: [],
      button_list: [],
      last_index_emoji: null,
      wa_auth_wording,
      flowList: [],
      flowID: '',
      panels: [
        {
          name: 'Layout',
          icon: 'bulletin-board',
        },
        {
          name: 'Elements',
          icon: 'shape-outline',
        },
        {
          name: 'Settings',
          icon: 'cog-outline',
        },
      ],
      selectedPanel: {
        name: 'Layout',
        icon: 'bulletin-board',
      },
      editorOptions: {
        theme: 'snow',
        placeholder: 'Write your text here...',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            ['link'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ size: ['small', false, 'large', 'huge'] }],
            // [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }],
            [{ align: [] }],
          ],
        },
      },
      selectedElement: {},
      max_width_email: 600,
    };
  },
  computed: {
    sortedMappingComponents() {
      if (!Array.isArray(this.active_template.body.data)) return [];
      return [...this.active_template.body.data].sort((a, b) => a.order - b.order);
    },
    activeWorkspace() {
      return this.$store.state.workspace.activeWorkspace;
    },
    activeChannel() {
      return this.$store.state.channels.activeChannel;
    },
    isValidStep1() {
      return this.form1.category !== '' && this.form1.template_name !== '' && this.temp.selected_language.length > 0 && this.temp.groups_id.length > 0;
      // return this.form1.template_name !== '' && this.temp.selected_language.length > 0 && this.temp.groups_id.length > 0;
    },
    isMaxVariableHeader() {
      if (!this.active_template.header.content) return false;
      const match_regex = this.active_template.header.content.match(/({{\d{1,}}})/ig);
      return this.active_template.header.content && match_regex && match_regex.length > 0;
    },
    previewHeaderContent() {
      if (this.active_template.header.type === 'text') {
        if (this.active_template.header.example.data) {
          return this.active_template.header.content.replace('{{1}}', this.active_template.header.example.data);
        }
        return this.active_template.header.content;
      }
      return '';
    },
    previewFooterContent() {
      return this.active_template.footer.content;
    },
    previewContent() {
      let string = this.active_template.body.content;
      this.active_template.body.examples.forEach((v) => {
        if (v.text) {
          const replaceRegex = new RegExp(escapeRegExp(v.replacement), 'ig');
          string = string.replace(replaceRegex, v.text);
        }
      });
      // if (this.active_template.category === 'authentication') {
      //   string = this.wa_auth_wording[this.active_template.language].body;
      // }
      const htmlFormat = [
        { symbol: '*', tag: 'b' },
        { symbol: '_', tag: 'em' },
        { symbol: '~', tag: 'del' },
        { symbol: '```', tag: 'tt' },
        { symbol: '`', tag: 'mark' },
      ];

      htmlFormat.forEach(({ symbol, tag }) => {
        if (!string) return;
        const regex = new RegExp(`\\${symbol}([^${symbol}]*)\\${symbol}`, 'gm');
        const match = string.match(regex);
        if (!match) return;
        match.forEach((m) => {
          let formatted = m;
          /* eslint-disable no-plusplus */
          for (let i = 0; i < 2; i++) {
            formatted = formatted.replace(symbol, `<${i > 0 ? '/' : ''}${tag}>`);
          }
          string = string.replace(m, formatted);
        });
      });
      return string;
    },
    bodyHasParam() {
      if (!this.active_template.body) {
        return false;
      }
      // const matched = this.active_template.body.content.match(/({{\d{1,}}})/ig);
      const matched = this.active_template.body.content.match(/{{\s*\d+\s*}}/g);
      if (!matched) {
        return false;
      }
      return matched && matched.length ? uniq(matched) : [];
    },
    headerHasParamOrMedia() {
      if (!this.active_template.header) {
        return false;
      }
      const header_media = this.active_template.header.type === 'media';
      const header_carousel = this.active_template.header.type === 'carousel' && this.active_template.header.content ? this.active_template.header.content.match(/({{\d{1,}}})/ig) : false;
      const header_has_param = this.active_template.header.type === 'text' && this.active_template.header.content ? this.active_template.header.content.match(/({{\d{1,}}})/ig) : false;
      return header_has_param || header_media || header_carousel;
    },
    buttonHasDynamic() {
      if (!this.active_template.buttons) {
        return false;
      }
      if (this.active_template.category === 'authentication') {
        return true;
      }
      let has_dynamic = false;
      const url_btn = this.active_template.buttons.content.filter((v) => v.type === 'url' && v.url_type === 'dynamic');
      if (url_btn.length > 0) {
        has_dynamic = true;
      }
      return has_dynamic;
    },
    isNeedSample() {
      return this.bodyHasParam || this.headerHasParamOrMedia || this.buttonHasDynamic;
    },
    isInvalidExample() {
      if (!this.example_template.body) {
        return false;
      }
      if (this.buttonHasDynamic && !this.example_template.buttons.examples.filter((v) => v).length) {
        return true;
      }
      const empty_body_example = this.example_template.body.examples.find((v) => !v.text);
      return !isEmpty(empty_body_example);
    },
    isCompleteSample() {
      if (!this.active_template.body) {
        return false;
      }
      if (this.bodyHasParam) {
        if (this.active_template.body && this.active_template.body.examples.length === 0) {
          return false;
        }
        if (this.bodyHasParam.length > 0 && this.bodyHasParam.length !== this.active_template.body.examples.length) {
          return false;
        }
      }
      if (this.headerHasParamOrMedia && (isEmpty(this.active_template.header.example.data))) {
        return false;
      }
      if (!this.headerHasParamOrMedia && this.active_template.header.example.data) {
        return false;
      }
      if (this.buttonHasDynamic && !this.active_template.buttons.examples.filter((v) => v).length) {
        return false;
      }
      if (!this.cardSampleIsComplete) {
        return false;
      }
      const button_example = this.active_template.buttons.content.filter((item) => item.type === 'url' && item.url_type === 'dynamic');
      if (button_example.length > 0) {
        if (this.active_template.buttons.examples.filter((v) => v).length !== button_example.length) {
          return false;
        }
      }
      const empty_body_example = this.active_template.body.examples.find((v) => !v.text);
      return isEmpty(empty_body_example);
    },
    cardSampleIsComplete() {
      const incomplete = [];
      if (this.active_template.header.type === 'carousel') {
        for (let i = 0; i < this.active_template.carousel.length; i++) {
          if (!this.isCompleteSampleCard(i)) {
            incomplete.push(i);
          }
        }
      }
      return !incomplete.length;
    },
  },
  mounted() {
    this.getListDivisions();
    const { state } = window.history;
    if (state?.template && state?.form && state?.step && state?.temp && state?.selectedElement) {
      this.active_template = state.template;
      this.template_form = [state.template];
      this.temp = state.temp;
      this.form1 = state.form;
      this.step = state.step;
      this.selectedElement = state.selectedElement;
    }
    if (Object.values(this.selectedElement).length > 0) {
      this.clearEditElement();
    }
  },
  methods: {
    extractNumberArray(str) {
      return str.split(',').map((v) => parseInt(v, 10));
    },
    startDrag(evt, category, size) {
      evt.dataTransfer.dropEffect = 'move';
      evt.dataTransfer.effectAllowed = 'move';
      if (size) {
        evt.dataTransfer.setData('size', size);
      }
      evt.dataTransfer.setData('category', category);
    },
    getInitialFullTemplateHTML() {
      return `
        <html translate="no">
        <head>
            <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <style type="text/css" id="responsive-stack-styles">
       
                .wrapper_font { font-size: 15px; }
                .button_el {
                  font-size: 15px;
                }
                  
                @media screen and (max-width: 600px) {
                    .stack {
                        width: 100% !important;
                        display: block !important;
                        text-align: center !important;
                        box-sizing: border-box !important;
                    }
                    
                    .stack > div {
                        text-align: center !important;
                    }
                        
                    img {
                      max-width: 100% !important;
                    }
              
                    .template-img {
                      max-width: 100% !important;
                    }
                }
            </style>
        </head>
        <body translate="no">
            <div class="container">
                <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%">
                    <tr>
                        <td align="center" valign="top">
                            <div id="row" style="width: 100%;">
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </body>
        </html>
      `;
    },
    onDrop(evt, layout_id, column_number) {
      evt.stopPropagation();
      const idx_drag_column = parseInt(evt.dataTransfer.getData('column_drag_number'), 10);
      const idx_drag_element = parseInt(evt.dataTransfer.getData('idx_drag_element'), 10);
      const idx_drag_layout = parseInt(evt.dataTransfer.getData('idx_drag_layout'), 10);
      const category = evt.dataTransfer.getData('category');
      const size = evt.dataTransfer.getData('size');
      // Drop a new layout (columns)
      if (category.includes('column')) {
        const id = Math.random().toString(36).substring(2, 9);
        if (!this.active_template.body.content) {
          this.active_template.body.content = this.getInitialFullTemplateHTML();
        }
        const columns = this.extractNumberArray(size);
        this.dropConvertHtmlColumn(id, columns);
        const mapping_column = columns.reduce((acc, v, i) => {
          acc[`container_${i + 1}`] = [];
          return acc;
        }, {});
        const layoutComponent = {
          id,
          type: 'layout',
          category,
          column: columns,
          content: mapping_column,
          order: this.active_template.body.data.length + 1,
        };
        this.active_template.body.data.push(layoutComponent);
        return;
      }
      // Drop a new element (button, text, etc.)
      if (['button', 'font', 'spacer', 'divider', 'image'].includes(category)) {
        const container_name = `container_${column_number}`;
        const layout_index = this.active_template.body.data.findIndex((v) => v.id === layout_id);
        if (layout_index === -1) return;
        const column = this.active_template.body.data[layout_index].content[container_name];
        const id = Math.random().toString(36).substring(2, 9);
        this.dropConvertHtmlElements(id, category, layout_id, column_number);
        const newComponent = {
          id,
          type: 'element',
          text: category === 'button' ? 'Type Here' : '',
          category,
          order: column.length + 1,
        };
        if (category === 'button') {
          Object.assign(newComponent, {
            container_style: 'boxed',
            background: 'color',
            color: '#118c7f',
            align: 'left',
          });
        } else if (category === 'spacer') {
          newComponent.spacer = 30;
        } else if (category === 'divider') {
          Object.assign(newComponent, {
            weight: 1,
            width: 100,
            color: '#2f2f2f',
            style: 'solid',
          });
        } else if (category === 'image') {
          Object.assign(newComponent, { align: 'left', height: this.max_width_email, width: this.max_width_email });
        }
        column.push(newComponent);
        return;
      }
      // Move element to other layout
      if (!Number.isNaN(idx_drag_layout) && !Number.isNaN(idx_drag_column) && !Number.isNaN(idx_drag_element)) {
        const from_container = `container_${idx_drag_column}`;
        const source_layout = this.active_template.body.data[idx_drag_layout];
        const draggedElement = source_layout.content[from_container][idx_drag_element];
        if (!draggedElement) return;
        const dest_layout_index = this.active_template.body.data.findIndex((v) => v.id === layout_id);
        const dest_layout = this.active_template.body.data[dest_layout_index];
        if (dest_layout_index === -1 || !dest_layout) return;
        if (
          idx_drag_layout === dest_layout_index
          && from_container === `container_${column_number}`
        ) return;
        const parser = new DOMParser();
        const doc = parser.parseFromString(this.active_template.body.content || '', 'text/html');
        const elementNode = doc.getElementsByClassName(draggedElement.id)[0];
        const columnElement = doc.getElementById(`${dest_layout.id}_container${column_number}`);
        const destinationNode = doc.getElementsByClassName(`content_wrapper_${dest_layout.id}_container${column_number}`)[0];
        if (elementNode) {
          const width_percent = columnElement.style.width;
          const column_percent = parseFloat(width_percent) / 100;
          const max_size = Math.round(this.max_width_email * column_percent);
          const imgElement = elementNode.querySelector('img');
          if (imgElement) {
            const currentWidth = parseFloat(imgElement.style.width) || parseFloat(imgElement.getAttribute('width')) || 0;
            const currentHeight = parseFloat(imgElement.style.height) || parseFloat(imgElement.getAttribute('height')) || 0;

            if (currentWidth > max_size) {
              imgElement.style.width = `${max_size}px`;
              imgElement.setAttribute('width', max_size);
            }
            if (currentHeight > max_size) {
              imgElement.style.height = `${max_size}px`;
              imgElement.setAttribute('height', max_size);
            }
          }
        }
        if (elementNode && destinationNode) destinationNode.appendChild(elementNode);
        this.active_template.body.content = doc.documentElement.outerHTML;
        const movedElement = source_layout.content[from_container].splice(idx_drag_element, 1)[0];
        dest_layout.content[`container_${column_number}`].push(movedElement);
      }
    },
    startDragOrderLayout(evt, idx_layout) {
      evt.dataTransfer.dropEffect = 'move';
      evt.dataTransfer.effectAllowed = 'move';
      evt.dataTransfer.setData('idx_drag_layout', idx_layout);
    },
    startDragOrderElement(evt, idx_layout, column_number, idx_element) {
      evt.dataTransfer.dropEffect = 'move';

      evt.dataTransfer.effectAllowed = 'move';
      evt.dataTransfer.setData('idx_drag_layout', idx_layout);
      evt.dataTransfer.setData('column_drag_number', column_number);
      evt.dataTransfer.setData('idx_drag_element', idx_element);
      evt.dataTransfer.setData('order_drag_element', true);
    },
    onDropAdjustOrderLayout(evt, idx_layout) {
      const idx_drag_layout = parseInt(evt.dataTransfer.getData('idx_drag_layout'), 10);
      if (Number.isNaN(idx_drag_layout) || idx_layout === idx_drag_layout) return;
      const { data } = this.active_template.body;

      if (
        !Array.isArray(data)
        || idx_drag_layout < 0
        || idx_drag_layout >= data.length
        || idx_layout < 0
        || idx_layout >= data.length
      ) return;

      const layout_A = data[idx_drag_layout];
      const layout_B = data[idx_layout];

      this.$set(data, idx_drag_layout, layout_B);
      this.$set(data, idx_layout, layout_A);

      const tempOrder = layout_A.order;
      layout_A.order = layout_B.order;
      layout_B.order = tempOrder;

      this.swapElementsByClass(layout_A.id, layout_B.id);
    },
    onDropAdjustOrderElement(evt, idx_layout, column_number, idx_element) {
      const is_order_element = evt.dataTransfer.getData('order_drag_element');
      if (!is_order_element) {
        this.onDropAdjustOrderLayout(evt, idx_layout);
        return;
      }
      const idx_drag_element = parseInt(evt.dataTransfer.getData('idx_drag_element'), 10);
      if (Number.isNaN(idx_drag_element) || idx_element === idx_drag_element) return;
      const container_name = `container_${column_number}`;
      const container_content = this.active_template.body.data[idx_layout].content[container_name];
      if (
        !Array.isArray(container_content)
        || idx_drag_element < 0
        || idx_drag_element >= container_content.length
        || idx_element < 0
        || idx_element >= container_content.length
      ) return;

      const element_A = container_content[idx_drag_element];
      const element_B = container_content[idx_element];

      this.$set(container_content, idx_drag_element, element_B);
      this.$set(container_content, idx_element, element_A);

      const tempOrder = element_A.order;
      element_A.order = element_B.order;
      element_B.order = tempOrder;
      this.swapElementsByClass(element_A.id, element_B.id);
    },
    checkComplete() {
      const bodyData = this.active_template.body.data;

      if (bodyData.length === 0) return true;

      const hasEmptyBody = bodyData.some((row) => {
        const keys = Object.keys(row.content);
        return keys.some((k) => row.content[`${k}`].length === 0);
      });

      if (hasEmptyBody) return true;

      if (this.active_template.header.type === 'carousel') {
        for (let i = 0; i < this.active_template.carousel.length; i++) {
          if (!this.isCompleteSampleCard(i)) {
            return true;
          }
        }
      }
      return false;
    },
    isCompleteSampleCard(key) {
      if (!this.active_template.carousel[key].body.content) {
        return false;
      }
      const bodyParam = this.active_template.carousel[key].body.content.match(/({{\d{1,}}})/ig);
      if (bodyParam) {
        if (this.active_template.carousel[key].body && this.active_template.carousel[key].body.examples.length === 0) {
          return false;
        }
        if (bodyParam.length > 0 && bodyParam.length !== this.active_template.carousel[key].body.examples.length) {
          return false;
        }
      }
      if (!this.active_template.carousel[key].header.example.data || !this.active_template.carousel[key].header.example.base64) {
        return false;
      }
      if (this.active_template.carousel[key].buttons.content.filter((v) => !v.text).length > 0) {
        return false;
      }
      const check_url = this.active_template.carousel[key].buttons.content.filter((v) => v.type === 'url').length;
      if (check_url > 0) {
        if (this.active_template.carousel[key].buttons.content.filter((v) => v.url_type).length < check_url) {
          return false;
        }
        if (this.active_template.carousel[key].buttons.content.filter((v) => v.url).length < check_url) {
          return false;
        }
      }
      const check_url_dynamic = this.active_template.carousel[key].buttons.content.filter((v) => v.type === 'url' && v.url_type === 'dynamic').length;
      const count_url_dynamic = this.active_template.carousel[key].buttons.examples.filter((v) => v !== '').length;
      if (count_url_dynamic !== check_url_dynamic) {
        return false;
      }
      const check_body_dynamic = this.active_template.carousel[key].body.content.match(/({{\d{1,}}})/ig)?.length || 0;
      const count_body_dynamic = this.active_template.carousel[key].body.examples.filter((v1) => v1.text).length;
      if (count_body_dynamic !== check_body_dynamic) {
        return false;
      }
      const check_phone = this.active_template.carousel[key].buttons.content.filter((v) => v.type === 'phone_number').length;
      if (check_phone > 0) {
        if (this.active_template.carousel[key].buttons.content.filter((v) => v.country_code).length < check_phone) {
          return false;
        }
        if (this.active_template.carousel[key].buttons.content.filter((v) => v.phone_number).length < check_phone) {
          return false;
        }
      }
      const empty_body_example = this.active_template.carousel[key].body.examples.filter((v) => !v.text);
      if (empty_body_example > 0) {
        return false;
      }
      return true;
      // return isEmpty(empty_body_example);
    },
    previewContentCarousel(key) {
      let string = this.active_template.carousel[key].body.content;
      this.active_template.carousel[key].body.examples.forEach((v) => {
        if (v.text) {
          const replaceRegex = new RegExp(escapeRegExp(v.replacement), 'ig');
          string = string.replace(replaceRegex, v.text);
        }
      });
      // if (this.active_template.category === 'authentication') {
      //   string = this.wa_auth_wording[this.active_template.language].body;
      // }
      const htmlFormat = [
        { symbol: '*', tag: 'b' },
        { symbol: '_', tag: 'em' },
        { symbol: '~', tag: 'del' },
        { symbol: '```', tag: 'tt' },
        { symbol: '`', tag: 'mark' },
      ];

      htmlFormat.forEach(({ symbol, tag }) => {
        if (!string) return;
        const regex = new RegExp(`\\${symbol}([^${symbol}]*)\\${symbol}`, 'gm');
        const match = string.match(regex);
        if (!match) return;
        match.forEach((m) => {
          let formatted = m;
          /* eslint-disable no-plusplus */
          for (let i = 0; i < 2; i++) {
            formatted = formatted.replace(symbol, `<${i > 0 ? '/' : ''}${tag}>`);
          }
          string = string.replace(m, formatted);
        });
      });
      return string;
    },
    previewFooterContentCarousel(key) {
      return this.active_template.carousel[key].footer.content;
    },
    checkUrl(idx) {
      const regex = RegExp('(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+@]*)*(\\?[;&a-z\\d%_.~+=-@]*)?(\\#[-a-z\\d_@]*)?$', 'i');
      // if (!this.active_template.buttons.content[idx].url.match(regex)) {
      //   return this.active_template.buttons.content[idx].url.match(regex);
      // }
      let result = true;
      if (this.active_template.buttons.content[idx].url !== '') {
        result = this.active_template.buttons.content[idx].url.match(regex);
      }
      return result;
    },
    checkContent(item) {
      const content = this.active_template.buttons.content.filter((v) => item.group.includes(v.type)).length;
      return content > 0 || this.active_template.buttons.content.length >= 10;
    },
    checkFirstButton(type) {
      const content = this.footer_category.find((v) => v.group.includes(type));
      return content.type;
    },
    buttonList() {
      let content = [];
      if (this.active_template.buttons.content.length > 3) {
        content = this.active_template.buttons.content.filter((v) => this.checkFirstButton(v.type) === this.checkFirstButton(this.active_template.buttons.content[0].type)).slice(0, 2);
        if (content.length === 2) {
          this.button_list = content;
        } else {
          this.button_list[0] = this.active_template.buttons.content[0];
          this.button_list[1] = this.active_template.buttons.content[1];
        }
      }
    },
    showAllButtons() {
      this.isShowModal.allButton = !this.isShowModal.allButton;
    },
    setSelectedCategory(item) {
      this.form1.category = item.key;
    },
    backToList() {
      this.$router.push({
        name: 'Broadcast Templates Email',
      });
    },
    backToStep(i) {
      this.step = i;
      if (i === 1) {
        this.is_back_template = true;
      }
    },
    createTemplateObject(languageValue) {
      const languageInfo = this.languages_list.find((lg) => lg.value === languageValue);

      const obj = {
        template_name: this.form1.template_name,
        category: this.form1.category,
        language_str: languageInfo ? languageInfo.label : 'indonesia',
        language: languageValue,
        body: {
          data: [],
          content: '',
          examples: [],
        },
        header: {
          type: 'none',
          content: '',
          example: { data: '', base64: '' },
        },
        footer: {
          content: '',
          examples: [],
        },
        buttons: {
          parent_type: 'none',
          content: [],
          examples: [],
        },
        carousel: [
          {
            body: {
              content: '',
              examples: [],
            },
            header: {
              type: 'none',
              content: 'image',
              file: null,
              example: { data: '', base64: '' },
            },
            footer: {
              content: '',
              examples: [],
            },
            buttons: {
              parent_type: 'call_to_action',
              content: [{
                type: 'url',
                url_type: '',
                text: '',
                url: '',
                phone_number: undefined,
                country_code: undefined,
              }],
              examples: [],
            },
          },
        ],
        otp_delivery_type: 'copy_code',
        otp_button_text: '',
        otp_autofill_text: '',
        otp_package_name: '',
        otp_signature_hash: '',
        otp_add_security_wording: false,
        otp_add_expiry_wording: false,
        otp_expires_in: 5,
      };
      if (this.form1.category.toLowerCase() === 'authentication') {
        obj.body.content = this.wa_auth_wording[languageValue].body;
        obj.body.examples = [
          {
            replacement: '{{1}}',
            text: '123456',
          },
        ];
        obj.buttons = {
          parent_type: 'call_to_action',
          content: [
            {
              type: 'otp',
              url_type: 'dynamic',
              text: obj.otp_button_text,
              url: 'https://www.whatsapp.com/otp/code/?otp_type=COPY_CODE&code=otp{{1}}',
            },
          ],
          examples: [
            'https://www.whatsapp.com/otp/code/?otp_type=COPY_CODE&code=otp123456',
          ],
        };
      }

      return obj;
    },
    nextStep(fromStep) {
      if (!this.is_back_template) {
        /** Create template when first time  */
        this.template_form = this.temp.selected_language.map((v) => this.createTemplateObject(v));
      } else {
        /** Restore template with old input when using back button  */
        const filtered_templates = this.template_form.filter((v) => this.temp.selected_language.includes(v.language)).map((v) => {
          v.template_name = this.form1.template_name;
          return v;
        });
        this.template_form = filtered_templates;
      }

      this.step = fromStep + 1;
      this.active_template = this.template_form[0];
    },
    setActiveTemplate(lang) {
      this.template_form = this.template_form.map((v) => {
        if (v.language === this.active_template.language) {
          return this.active_template;
        }
        return v;
      });
      this.active_template = this.template_form.find((v) => v.language === lang);
    },
    handlerInputTemplateName(event, target) {
      if (target === 'edit_template_name') {
        this.temp.template_name = this.temp.template_name.replace(/\s/g, '_');
        this.temp.template_name = this.temp.template_name.toLowerCase();
      } else if (target === 'create_template_name') {
        this.form1.template_name = this.form1.template_name.replace(/\s/g, '_');
        this.form1.template_name = this.form1.template_name.toLowerCase();
      }
    },
    showModalEditTemplateName() {
      this.temp.template_name = this.form1.template_name;
      this.isShowModal.editTemplateName = true;
    },
    onSubmitEditTemplateName() {
      this.form1.template_name = this.temp.template_name;
      this.temp.template_name = '';
      this.isShowModal.editTemplateName = false;
    },
    closeModalEditTemplate() {
      this.temp.template_name = '';
      this.isShowModal.editTemplateName = false;
    },
    addVariableBody(layoutIndex, containerIndex, elementIndex) {
      const layout = this.active_template.body.data[layoutIndex];
      if (!layout) return;

      const container_key = `container_${containerIndex + 1}`;
      const element = layout.content[container_key]?.[elementIndex];
      if (!element) return;

      const parser = new DOMParser();
      const doc = parser.parseFromString(this.active_template.body.content || '', 'text/html');

      const current_html = this.active_template.body.content || '';
      const total_variables = current_html.match(/{{\s*\d+\s*}}/g);
      const next_index = total_variables ? total_variables.length + 1 : 1;
      const new_variable = ` {{${next_index}}}`;

      const target_els = doc.getElementsByClassName(element.id);
      if (!target_els.length) return;

      const target_el = target_els[0];
      let button_text = '';

      if (element.category === 'button') {
        let button_el = target_el.querySelector('a');
        if (!button_el) {
          const btns = target_el.getElementsByTagName('a');
          if (btns && btns.length > 0) button_el = btns[0];
        }

        if (button_el) {
          button_el.innerHTML = `${button_el.innerHTML.trim()}${new_variable}`;
          button_text = button_el.innerHTML;
        } else {
          target_el.innerHTML += new_variable;
          button_text = target_el.innerHTML;
        }
      } else if (element.category === 'font') {
        const p_el = target_el.querySelector('p');
        if (p_el) {
          p_el.innerHTML = `${p_el.innerHTML.trim()}${new_variable}`;
        } else {
          target_el.innerHTML = `${target_el.innerHTML.trim()}${new_variable}`;
        }
      }

      element.text = element.category === 'button' ? button_text : target_el.innerHTML;

      this.active_template.body.content = doc.documentElement.outerHTML;

      if (this.$refs.inputBodyContent) {
        this.$refs.inputBodyContent.focus();
      }
    },
    handlerInputBodyContent(event, layout_index, container_index, element_index) {
      const { keyCode, shiftKey } = event;
      if (keyCode !== 219 || !shiftKey) return;

      const layout = this.active_template.body.data[layout_index];
      if (!layout) return;

      const container_key = `container_${container_index + 1}`;
      const element = layout.content?.[container_key]?.[element_index];
      if (!element) return;

      element.text = `${element.text || ''}`;
      const has_html = /<\/?[a-z][\s\S]*>/i.test(element.text);
      let last_text = element.text;

      let last_el = null;
      if (has_html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(element.text, 'text/html');
        const all_nodes = Array.from(doc.body.querySelectorAll('*')).filter(
          (el) => el.textContent.trim().length > 0,
        );
        if (all_nodes.length > 0) {
          last_el = all_nodes[all_nodes.length - 1];
          last_text = last_el.textContent;
        }
      }

      if (!(element.text.endsWith('{') || last_text.endsWith('{'))) return;

      event.preventDefault();

      const current_html = this.active_template.body.content || '';
      const total_variables = current_html.match(/{{\s*\d+\s*}}/g);
      const next_index = total_variables ? total_variables.length + 1 : 1;
      const new_variable = `{{${next_index}}}`;

      if (has_html && last_el) {
        last_el.innerHTML = last_el.innerHTML.replace(/\{$/, new_variable);
        const outer_doc = new DOMParser().parseFromString(element.text, 'text/html');
        const all_nodes = outer_doc.body.querySelectorAll('*');
        if (all_nodes.length > 0) {
          all_nodes[all_nodes.length - 1].innerHTML = last_el.innerHTML;
        }
        element.text = outer_doc.body.innerHTML;
      } else {
        element.text = element.text.replace(/\{$/, new_variable);
      }

      const parser = new DOMParser();
      const doc = parser.parseFromString(this.active_template.body.content, 'text/html');
      const element_button = doc.getElementsByClassName(`button_${element.id}`)[0];
      const element_font = doc.getElementsByClassName(`${element.id}`)[0];

      if (element_button) {
        element_button.textContent = element.text;
      } else if (element_font) {
        const all_nodes = Array.from(element_font.querySelectorAll('*')).filter(
          (el) => el.textContent.trim().length > 0,
        );

        if (all_nodes.length > 0) {
          const last_dom_el = all_nodes[all_nodes.length - 1];
          last_dom_el.innerHTML = last_el ? last_el.innerHTML : element.text;
        } else {
          element_font.innerHTML += element.text;
        }
      }

      this.active_template.body.content = doc.documentElement.outerHTML;
    },
    handlerChangeButtonsParent(value) {
      if (value === 'none') {
        this.active_template.buttons.content = [];
        this.active_template.buttons.examples = [];
      } else if (value === 'quick_reply') {
        const idx = this.active_template.buttons.content.findLastIndex((v) => v.type === 'quick_reply');
        this.active_template.buttons.content.splice(idx + 1, 0, {
          type: 'quick_reply',
          text: '',
        });
        this.active_template.buttons.examples.splice(idx + 1, 0, null);
      } else if (value === 'call_to_action') {
        const idx = this.active_template.buttons.content.findLastIndex((v) => v.type !== 'quick_reply');
        this.active_template.buttons.content.splice(idx + 1, 0, {
          type: 'url',
          url_type: 'static',
          text: '',
          url: '',
          phone_number: undefined,
          country_code: undefined,
          flow_id: undefined,
          flow_action: undefined,
          navigate_screen: undefined,
        });
        this.active_template.buttons.examples.splice(idx + 1, 0, null);
      }
      this.buttonList();
    },
    addButtonQuickReply() {
      const idx = this.active_template.buttons.content.findLastIndex((v) => v.type === 'quick_reply');
      this.active_template.buttons.content.splice(idx + 1, 0, {
        type: 'quick_reply',
        text: '',
      });
      this.active_template.buttons.examples.splice(idx + 1, 0, null);
      this.buttonList();
    },
    handlerRemoveQuickReply(index) {
      this.active_template.buttons.content.splice(index, 1);
      this.active_template.buttons.examples.splice(index, 1);
      if (this.active_template.buttons.content.length === 0) {
        this.active_template.buttons.parent_type = 'none';
      } else if (this.active_template.buttons.content.filter((v) => v.type === 'quick_reply').length === 0) {
        this.active_template.buttons.parent_type = 'call_to_action';
      }
      this.buttonList();
    },
    addButtonCTA() {
      // const current_button = this.active_template.buttons.content[0];
      const idx = this.active_template.buttons.content.findLastIndex((v) => v.type !== 'quick_reply');
      const form = {
        copy_code: {
          type: 'copy_code',
          text: '',
        },
        url: {
          type: 'url',
          url_type: 'static',
          text: '',
          url: '',
        },
        phone_number: {
          type: 'phone_number',
          text: '',
          phone_number: '',
          country_code: '+62',
        },
        flow: {
          type: 'flow',
          text: '',
          flow_id: '',
          flow_action: '',
          navigate_screen: '',
        },
      };
      let push = 0;
      this.call_to_action_category.forEach((v) => {
        const len = this.active_template.buttons.content.filter((x) => x.type === v.type).length;
        if (len < v.max_length && push === 0) {
          this.active_template.buttons.content.splice(idx + 1, 0, form[v.type]);
          this.active_template.buttons.examples.splice(idx + 1, 0, null);
          push = 1;
        }
      });
      this.buttonList();
    },
    handlerRemoveCTA(index) {
      if (this.active_template.buttons.content[index].type === 'flow') {
        this.flowID = '';
      }
      this.active_template.buttons.content.splice(index, 1);
      this.active_template.buttons.examples.splice(index, 1);
      if (this.active_template.buttons.content.length === 0) {
        this.active_template.buttons.parent_type = 'none';
      } else if (this.active_template.buttons.content.filter((v) => v.type !== 'quick_reply').length === 0) {
        this.active_template.buttons.parent_type = 'quick_reply';
      }
      this.buttonList();
    },
    handlerRemoveLanguageContent(selected_template) {
      const index = this.template_form.findIndex((v) => v.language === selected_template.language);
      this.active_template = this.template_form[(index > 0 ? index - 1 : index + 1)];
      this.temp.selected_language.splice(this.temp.selected_language.findIndex((v) => v === selected_template.language), 1);
      this.template_form.splice(index, 1);
    },
    handlerRemoveCardContent(key) {
      this.active_template.carousel.splice(key, 1);
    },
    handlerAddMoreLanguage(value) {
      const obj = {
        template_name: this.form1.template_name,
        category: this.form1.category,
        language_str: this.languages_list.find((lg) => lg.value === value).label,
        language: value,
        body: {
          content: '',
          examples: [],
        },
        header: {
          type: 'none',
          content: '',
          example: { data: '' },
        },
        footer: {
          type: '',
          examples: [],
        },
        buttons: {
          parent_type: 'none',
          content: [],
          examples: [],
        },
        carousel: [
          {
            body: {
              content: '',
              examples: [],
            },
            header: {
              type: 'none',
              content: 'image',
              file: null,
              example: { data: '', base64: '' },
            },
            footer: {
              content: '',
              examples: [],
            },
            buttons: {
              parent_type: 'call_to_action',
              content: [{
                type: 'url',
                url_type: '',
                text: '',
                url: '',
                phone_number: undefined,
                country_code: undefined,
              }],
              examples: [],
            },
          },
        ],
      };
      this.temp.selected_language.push(value);
      this.template_form.push(obj);
      this.addMoreLanguage = '';
    },
    addVariableHeader() {
      this.active_template.header.content += '{{1}}';
    },
    handlerInputHeaderContent(event) {
      const { keyCode, shiftKey } = event;
      if (keyCode === 219 && shiftKey) {
        if (this.active_template.header.content.endsWith('{')) {
          if (!this.active_template.header.content) {
            this.active_template.header.content = '';
          }
          const total_variable = this.active_template.header.content.match(/({{\d{1,}}})/ig);
          if (!total_variable || !total_variable.length) {
            this.active_template.header.content += `{${total_variable ? total_variable.length + 1 : 1}}}`;
            this.$refs.inputHeaderContent.focus();
            event.preventDefault();
          }
        }
      }
    },
    async submitTemplate() {
      this.loading.submit = true;
      this.clearEditElement();
      const response = await notifApi.submitRequestTemplate({
        workspace_id: this.activeWorkspace._id,
        channel_id: this.activeChannel._id,
        templates: this.template_form,
        groups_id: this.temp.groups_id,
      });
      const { error } = response;
      this.loading.submit = false;
      if (error) {
        await popupErrorMessages(response);
      } else {
        this.$message({
          message: this.$t('templates.success.request_template'),
          type: 'success',
        });
        this.$router.push({
          name: 'Broadcast Templates Email',
        });
      }
    },
    addSampleContent() {
      if (!this.active_template.body.examples) {
        this.active_template.body.examples = [];
      }
      const params = this.bodyHasParam || [];

      this.active_template.body.examples = params.map((v) => {
        const existing = this.active_template.body.examples.find((e) => e.replacement === v);
        return existing || { replacement: v, text: '' };
      });

      if (params.length === 0) {
        this.active_template.body.examples = [];
      }

      if (!this.headerHasParamOrMedia && this.active_template.header) {
        this.active_template.header.example.data = '';
      }

      this.example_template = cloneDeep(this.active_template);
      this.isShowModal.addSample = true;
    },
    showCarouselCard(key) {
      this.active_card = key;
      this.isShowModal.carouselCard = true;
    },
    addCarouselCard() {
      const new_template = {
        body: {
          content: '',
          examples: [],
        },
        header: {
          type: 'none',
          content: 'image',
          file: null,
          example: { data: '', base64: '' },
        },
        footer: {
          content: '',
          examples: [],
        },
        buttons: {
          parent_type: 'call_to_action',
          content: [{
            type: 'url',
            url_type: '',
            text: '',
            url: '',
            phone_number: undefined,
            country_code: undefined,
          }],
          examples: [],
        },
      };
      if (this.active_template.carousel.length) {
        const sample = cloneDeep(this.active_template.carousel[0]);
        new_template.buttons.content = sample.buttons.content.map((v) => {
          v.url_type = '';
          v.text = '';
          v.url = '';
          v.phone_number = undefined;
          v.country_code = undefined;
          return v;
        });
      }
      const carousel_content = this.active_template.carousel;
      carousel_content.push(new_template);
      this.active_template.carousel = carousel_content;
    },
    submitChangeTemplateName() {
      this.active_template.template_name = this.temp.template_name;
      this.template_form = this.template_form.map((v) => {
        v.template_name = this.temp.template_name;
        return v;
      });
      this.form1.template_name = this.temp.template_name;
      this.isShowModal.editTemplateName = false;
    },
    submitExample() {
      this.active_template.body.examples = this.example_template.body.examples;
      this.active_template.header.example = this.example_template.header.example;
      this.active_template.buttons.examples = this.example_template.buttons.examples;
      this.isShowModal.addSample = false;
    },
    handlerChangeHeaderType() {
      this.active_template.header.example = {
        data: '',
        base64: '',
      };
      this.active_template.header.content = '';
    },
    async handlerFileHeaderMedia() {
      this.loading.upload_sample_media = true;
      if (this.example_template.header.file) {
        const formData = new FormData();
        formData.append('file', this.example_template.header.file);
        const response = await notifApi.uploadTemplateMedia(formData, this.activeWorkspace._id, this.activeChannel._id);
        await popupErrorMessages(response);
        this.example_template.header.example.data = response.data.h;
        this.example_template.header.example.base64 = await base64File(this.example_template.header.file);
      }
      this.loading.upload_sample_media = false;
    },
    async getListDivisions() {
      this.loading.table = true;
      const options = {
        workspace_id: this.activeWorkspace._id,
        channel_type: 'whatsapp',
      };
      const response = await divisions.listForTemplates(options);
      this.loading.table = false;
      await popupErrorMessages(response);
      const { data } = response;
      this.division_list = data.rows.map((v) => {
        v.created_at_str = moment(v.created_at).format('DD MMM YYYY, HH:mm');
        return v;
      });
      this.total = data.count;
    },
    addEmoji(emoji) {
      const pos = this.last_index_emoji !== null ? this.last_index_emoji : this.$refs.inputBodyContent.$refs.textarea.selectionStart;
      if (this.last_index_emoji === null) this.last_index_emoji = pos;
      const start_str = this.active_template.body.content.substring(0, pos);
      const end_str = this.active_template.body.content.substring(pos, this.active_template.body.content.length);
      this.active_template.body.content = [start_str, emoji.native, end_str].join('');
    },
    handlerOtpTypeRadio(type) {
      this.active_template.otp_delivery_type = type;
    },
    checkedSecurityChanged(value, lang) {
      if (value) {
        this.active_template.body.content += ` ${this.wa_auth_wording[lang].security_text}`;
      } else {
        this.active_template.body.content = this.active_template.body.content.replace(` ${this.wa_auth_wording[lang].security_text}`, '');
      }
    },
    handlerChangeOtpExpires() {
      this.checkedExpiryChanged(this.active_template.otp_add_expiry_wording, this.active_template.language);
    },
    checkedExpiryChanged(value, lang) {
      if (value) {
        this.active_template.footer = {
          content: this.wa_auth_wording[lang].footer_text.replace('{{expiry_time}}', this.active_template.otp_expires_in),
        };
      } else {
        this.active_template.footer = {
          type: '',
          examples: [],
        };
      }
    },
    async handlerSearchFlow(keyword = '') {
      const options = {
        page: 1,
        search: keyword,
        published: true,
      };
      this.flowList = [];
      this.loading.get_flows = true;
      await flowsAPI.get({
        workspace_id: this.activeWorkspace._id,
        options,
      }).then(async (res) => {
        this.flowList = res.data.rows;
        this.loading.get_flows = false;
      }).catch((err) => {
        console.log(err);
        this.loading.get_flows = false;
      });
    },
    async handlerDetailFlow() {
      await flowsAPI.detail({
        workspace_id: this.activeWorkspace._id,
        flow_id: this.flowID,
      }).then(async (res) => {
        await popupErrorMessages(res);
        const flow_idx = this.active_template.buttons.content.findIndex((v) => v.type === 'flow');
        this.active_template.buttons.content[flow_idx].flow_id = res.data.flow.provider_flow_id;
        this.active_template.buttons.content[flow_idx].flow_action = 'navigate';
        if (!isEmpty(res.data.flow.json_data.screens)) {
          this.active_template.buttons.content[flow_idx].navigate_screen = res.data.flow.json_data.screens[0].id;
        }
      });
    },
    saveBoxElements(layout_index, column_index, element_index) {
      delete this.selectedElement.status;
      const element = this.active_template.body.data[layout_index].content[`container_${column_index + 1}`];
      this.$delete(element[element_index], 'status');
    },
    editBoxElements(layout_index, column_index, element_index) {
      this.selectedElement = { ...this.selectedElement, status: 'edit' };
      const container_name = this.active_template.body.data[layout_index].content[`container_${column_index + 1}`];
      this.$set(container_name[element_index], 'status', 'edit');
    },
    deleteBoxElements(layout_index, column_index, element_index) {
      const element = this.active_template.body.data[layout_index].content[`container_${column_index + 1}`];
      this.removeHtmlByClass(element[element_index].id);
      element.splice(element_index, 1);
    },
    deleteBoxLayout(layout_index) {
      const layout = this.active_template.body.data[layout_index];
      this.removeHtmlByClass(layout.id);
      this.active_template.body.data.splice(layout_index, 1);
    },
    async onChangeUploadFile(event, layout_index, column_index, element_index) {
      const file = event.target.files[0];
      if (!file) return;

      const fileUrl = URL.createObjectURL(file);

      const parser = new DOMParser();
      const doc = parser.parseFromString(this.active_template.body.content, 'text/html');

      const targetElement = this.active_template.body.data[layout_index].content[`container_${column_index + 1}`][element_index];

      const els = doc.getElementsByClassName(`image_${targetElement.id}`);
      if (els.length > 0) {
        const el = els[0];
        el.setAttribute('src', fileUrl);
        el.style.width = '250px';
        el.style.height = '250px';
      }

      this.active_template.body.content = doc.documentElement.outerHTML;

      const fileBase64 = await this.toBase64(file);
      targetElement.file = {
        name: file.name,
        base64: fileBase64,
        url: fileUrl,
      };
    },
    dropConvertHtmlColumn(id, columns) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(this.active_template.body.content, 'text/html');
      const row = doc.getElementById('row');
      if (!row) return;

      const existing_wrapper = doc.getElementById(`${id}_wrapper`);
      if (existing_wrapper) existing_wrapper.remove();

      const table = doc.createElement('table');
      table.id = `${id}_wrapper`;
      table.classList.add(id);
      table.setAttribute('width', '100%');
      table.setAttribute('border', '0');
      table.setAttribute('cellspacing', '0');
      table.setAttribute('cellpadding', '0');
      table.setAttribute(
        'style',
        'width:100%; border-collapse:collapse;',
      );

      const tbody = doc.createElement('tbody');
      const tr = doc.createElement('tr');
      columns.forEach((col, index) => {
        const td = doc.createElement('td');
        const width_percent = parseFloat((col / 12) * 100);

        td.id = `${id}_container${index + 1}`;
        td.classList.add('stack');
        td.setAttribute('width', `${width_percent}%`);
        td.setAttribute(
          'style',
          `
            width: ${width_percent}%;
            padding: 5px;
            vertical-align: top;
            text-align: center;
          `.trim(),
        );
        const column_percent = parseFloat(width_percent) / 100;
        const max_size = Math.round(this.max_width_email * column_percent);
        const div_wrapper = doc.createElement('div');
        div_wrapper.className = `content_wrapper_${id}_container${index + 1}`;
        div_wrapper.style.setProperty('max-width', `${max_size}px`, 'important');
        div_wrapper.style.setProperty('width', '100%', 'important');
        div_wrapper.style.margin = '0 auto';
        div_wrapper.style.display = 'inline-block';
        div_wrapper.style.backgroundColor = 'transparent';
        td.appendChild(div_wrapper);
        tr.appendChild(td);
      });

      tbody.appendChild(tr);
      table.appendChild(tbody);
      row.appendChild(table);
      this.active_template.body.content = doc.documentElement.outerHTML;
    },
    dropConvertHtmlElements(id, category, layout_id, column_number) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(this.active_template.body.content, 'text/html');

      const element_container = doc.getElementById(`${layout_id}_container${column_number}`);
      const div = element_container.getElementsByClassName(`content_wrapper_${layout_id}_container${column_number}`)[0];

      if (!div) return;

      const elementMap = {
        button: 'a',
        image: 'img',
        divider: 'div',
        spacer: 'div',
        font: 'div',
      };
      const tag = elementMap[category];
      if (!tag) return;

      const newElement = doc.createElement(tag);
      newElement.className = id;
      let wrapper = null;
      if (['button', 'image'].includes(category)) {
        newElement.className = category === 'image' ? `image_${id} template-img` : `button_${id} template-button`;
        let style;
        if (category === 'button') {
          style = 'white-space: pre-wrap; display: inline-block; cursor: pointer; color: white; font-family: Helvetica Neue, Helvetica, Arial, sans-serif;text-decoration: none !important; background-color: #128c7f; height: 100%; border: none; border-radius: 5px; padding: 10px; margin-bottom: 10px;';
          newElement.classList.add('button_el');
          newElement.textContent = 'Type Here';
        } else if (category === 'image') {
          const column_percent = parseFloat(div.style.width) / 100;
          const max_size = Math.round(this.max_width_email * column_percent);
          const calculated_size_px = max_size;
          style = `color: white; min-width: 80px; height: ${calculated_size_px}px; width: ${calculated_size_px}px; object-fit: cover; border-radius: 3px; padding: 10px; border: none; border-radius: 3px; margin-bottom: 10px;`;
          newElement.classList.add(`img-x2-${calculated_size_px}`);
          newElement.setAttribute(
            'src',
            'https://media.wappin.chat/template-header-image.png',
          );
        }
        newElement.setAttribute(
          'style',
          style,
        );
        wrapper = doc.createElement('div');
        wrapper.className = id;
        wrapper.setAttribute('style', 'text-align: left;');
        wrapper.appendChild(newElement);
      }
      if (category === 'divider') {
        const style = 'width: 100%; border-bottom: 1px solid black; margin: 1rem 0; margin-bottom: 10px;';
        newElement.setAttribute('style', style);
      } else if (category === 'spacer') {
        const style = 'width: 100%; height: 30px; margin-bottom: 10px;';
        newElement.setAttribute('style', style);
      } else if (category === 'font') {
        const style = 'margin-bottom: 10px; font-family: Helvetica Neue, Helvetica, Arial, sans-serif; font-size: ';
        newElement.classList.add('wrapper_font');
        newElement.setAttribute('style', style);
      }
      const elementToInsert = wrapper || newElement;
      if (!div.firstChild) {
        div.insertBefore(elementToInsert, div.firstChild);
      } else {
        div.appendChild(elementToInsert);
      }
      this.active_template.body.content = doc.documentElement.outerHTML;
    },
    onChangeConvertHtmlElements(id, category, layout_id, column_number, text) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(this.active_template.body.content, 'text/html');
      const element_container = doc.getElementById(`${layout_id}_container${column_number}`);
      const div = element_container.getElementsByClassName(`content_wrapper_${layout_id}_container${column_number}`)[0];

      if (!div) return;
      if (!['font', 'button'].includes(category)) return;
      let element_id = id;
      if (category === 'button') element_id = `button_${element_id}`;
      const layout = doc.getElementsByClassName(element_id);
      if (layout.length === 0) return;
      let convert_text = this.convertQuillSizes(text);
      convert_text = this.convertQuillHyperLink(convert_text);
      convert_text = this.convertQuillAlign(convert_text);
      layout[0].innerHTML = convert_text;

      this.active_template.body.content = doc.documentElement.outerHTML;
    },
    removeHtmlByClass(className) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(this.active_template.body.content, 'text/html');
      const elements = doc.getElementsByClassName(className);
      const elementsArray = Array.from(elements);
      elementsArray.forEach((el) => {
        const parent = el.parentElement;
        el.remove();
        if (parent) {
          const hasOnlyBr = Array.from(parent.childNodes).every(
            (node) => node.nodeName === 'BR'
              || (node.nodeType === Node.TEXT_NODE && !node.textContent.trim()),
          );
          if (hasOnlyBr) {
            const brs = parent.getElementsByTagName('br');
            Array.from(brs).forEach((br) => br.remove());
          }
        }
      });
      this.active_template.body.content = doc.documentElement.outerHTML;
    },
    swapElementsByClass(classA, classB) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(this.active_template.body.content, 'text/html');

      const elsA = doc.getElementsByClassName(classA);
      const elsB = doc.getElementsByClassName(classB);

      if (elsA.length === 0 || elsB.length === 0) return;

      const elA = elsA[0];
      const elB = elsB[0];

      const parentA = elA.parentNode;
      const parentB = elB.parentNode;
      if (!parentA || !parentB) return;

      if (parentA === parentB) {
        const children = Array.from(parentA.children);
        const indexA = children.indexOf(elA);
        const indexB = children.indexOf(elB);

        if (indexA < 0 || indexB < 0) return;
        if (indexA < indexB) {
          parentA.insertBefore(elB, elA);
          parentA.insertBefore(elA, children[indexB + 1] || null);
        } else {
          parentA.insertBefore(elA, elB);
          parentA.insertBefore(elB, children[indexA + 1] || null);
        }
      } else {
        const cloneA = elA.cloneNode(true);
        const cloneB = elB.cloneNode(true);
        parentA.replaceChild(cloneB, elA);
        parentB.replaceChild(cloneA, elB);
      }

      this.active_template.body.content = doc.documentElement.outerHTML.trim();
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    onSelectElement(el, idx_layout, idx_column, idx_element) {
      const layout = this.active_template.body.data[idx_layout];
      const parser = new DOMParser();
      const doc = parser.parseFromString(this.active_template.body.content, 'text/html');

      if (this.selectedElement?.status) {
        return;
      }
      const container = doc.getElementById(`${layout.id}_container${idx_column + 1}`);
      const column_percent = parseFloat(container.style.width) / 100;
      const max_size = Math.round(this.max_width_email * column_percent);
      const calculated_size_px = max_size;
      this.selectedElement = {
        ...el,
        idx_layout,
        idx_column,
        idx_element,
        max_size: calculated_size_px,
      };
      if (el.category === 'button' && !this.selectedElement.radius) {
        this.selectedElement.radius = 3;
      }
      if (el.category === 'image') {
        const select_image = doc.getElementsByClassName(`image_${el.id}`)[0];
        if (select_image) {
          let w = parseFloat(select_image.style.width);
          let h = parseFloat(select_image.style.height);

          if (Number.isNaN(w)) w = parseFloat(select_image.getAttribute('width')) || 0;
          if (Number.isNaN(h)) h = parseFloat(select_image.getAttribute('height')) || 0;

          this.selectedElement.width = w;
          this.selectedElement.height = h;
        }
      }
      if (el.width > max_size && el.height > max_size) {
        this.selectedElement.width = calculated_size_px;
        this.selectedElement.height = calculated_size_px;
      }

      this.active_template.body.data[idx_layout].content[`container_${(idx_column + 1)}`] = layout.content[`container_${(idx_column + 1)}`].map((v) => {
        if (el.id !== v.id) {
          delete v.status;
        }
        return v;
      });
      if (['button', 'divider', 'spacer', 'image'].includes(el.category)) {
        this.selectedPanel = {
          name: 'Settings',
          icon: 'cog',
        };
        return;
      }
      this.selectedPanel = {
        name: 'Elements',
        icon: 'view-dashboard-outline',
      };
    },
    onChangeSettings() {
      const { idx_layout, idx_column, idx_element } = this.selectedElement;

      const container_name = `container_${idx_column + 1}`;
      const layout = this.active_template.body.data[idx_layout];

      if (!layout || !layout.content) return;

      const target = layout.content[container_name][idx_element];
      if (!target) return;
      Object.assign(target, this.selectedElement);
      this.changeSettingsInterface(this.selectedElement, layout, container_name, idx_element);
    },
    applySettingsStyle(target, style) {
      if (!target) return;
      target.setAttribute('style', (style || '').trim());
    },
    convertSettingsUnit(val, defaultUnit = 'px') {
      if (val === null || val === undefined || val === '') return '';
      const s = String(val);
      return /^\d+(\.\d+)?$/.test(s) ? `${s}${defaultUnit}` : s;
    },
    changeSettingsInterface(element, layout, container_name, idx_element) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(this.active_template.body.content, 'text/html');
      const el = doc.getElementsByClassName(element.id)[0];
      layout.content[container_name][idx_element].text = el.textContent;
      if (!el) return;
      const justify = element.align || 'left';

      if (element.category === 'image') {
        this.applySettingsStyle(
          el,
          `
            width: 100%;
            padding: 10px;
            border-radius: 3px;
            text-align: ${justify};
            border: none;
          `,
        );

        const imageEl = doc.getElementsByClassName(`image_${element.id}`)[0] || el.querySelector('img');

        if (imageEl) {
          const imgWidth = element.width != null ? this.convertSettingsUnit(element.width) : imageEl.getAttribute('width') || 'auto';
          const imgHeight = element.height != null ? this.convertSettingsUnit(element.height) : imageEl.getAttribute('height') || 'auto';

          imageEl.style.cssText = `
            width: ${imgWidth};
            height: ${imgHeight};
            max-width: none;
            object-fit: ${element.objectFit || 'cover'};
          `;

          const parent = imageEl.parentNode;
          const isWrapped = parent.className === 'image_link';

          if (element.insert_link) {
            if (isWrapped) {
              parent.href = '#';
            } else {
              const link = Object.assign(doc.createElement('a'), {
                className: 'image_link', href: '#', target: '_blank',
              });
              parent.insertBefore(link, imageEl).appendChild(imageEl);
            }
          } else if (isWrapped) {
            parent.parentNode.insertBefore(imageEl, parent);
            parent.remove();
          }
        }
      } else if (element.category === 'button') {
        this.applySettingsStyle(
          el,
          `
            cursor: pointer;
            font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
            width: 100%;
            text-align: ${justify};
            margin-bottom: 10px;
            text-decoration: none !important;
          `,
        );
        const buttonEl = doc.getElementsByClassName(`button_${element.id}`)[0] || el.querySelector('a');
        if (buttonEl) {
          const borderRadius = element.radius ? this.convertSettingsUnit(element.radius) : buttonEl.style.borderRadius || '0px';

          this.applySettingsStyle(
            buttonEl,
            `
              width: ${element.container_style === 'full_width' ? '95%' : 'auto'};
              display: ${element.container_style === 'full_width' ? 'block' : 'inline'};
              text-align: ${element.container_style === 'full_width' ? 'center' : 'left'};
              height: 100%;
              background-color: ${element.background === 'color' ? element.color : 'transparent'};
              color: ${element.background === 'color' ? '#fff' : element.color || '#000'};
              border-radius: ${borderRadius};
              padding: 10px;
              white-space: pre-wrap; display: inline-block;
            `,
          );
        }
      } else if (element.category === 'divider') {
        this.applySettingsStyle(
          el,
          `
            width: ${element.width != null ? `${element.width}%` : '100%'};
            border-bottom: ${this.convertSettingsUnit(element.weight, 'px')} ${element.style || 'solid'} ${element.color || '#000'};
            margin: 1rem 0;
          `,
        );
      } else if (element.category === 'spacer') {
        const spacerHeight = element.spacer ?? 30;
        this.applySettingsStyle(el, `width: 100%; height: ${this.convertSettingsUnit(spacerHeight)}; display: block;`);
      }

      this.active_template.body.content = doc.documentElement.outerHTML;
    },
    previewDetail() {
      window.history.pushState(
        {
          template: this.active_template,
          step: this.step,
          form: this.form1,
          temp: this.temp,
          templateId: null,
          selectedElement: this.selectedElement,
        },
        '',
        '/broadcast-templates/email/preview',
      );
      this.$router.replace('/broadcast-templates/email/preview');
    },
    convertQuillHyperLink(text) {
      return text.replace(
        /href="(?!https?:\/\/)([^"]+)"/g,
        (match, url) => `href="https://${url}"`,
      );
    },
    removeClass(match, className) {
      return match
        .replace(new RegExp(`\\b${className}\\b`, 'g'), '')
        .replace(/\s{2,}/g, ' ')
        .replace(/class="\s*"/g, '');
    },
    applyQuillInlineStyle(tag, style) {
      if (tag.includes('style="')) {
        return tag.replace(/style="([^"]*)"/, `style="$1 ${style}"`);
      }
      return tag.replace(/>/, ` style="${style}">`);
    },
    convertQuillSizes(text) {
      return text
        .replace(/<(\w+)([^>]*?)class="([^"]*?ql-size-small[^"]*?)"([^>]*)>/g,
          (match) => {
            const styled = this.applyQuillInlineStyle(match, 'font-size:0.60em;');
            return this.removeClass(styled, 'ql-size-small');
          })
        .replace(/<(\w+)([^>]*?)class="([^"]*?ql-size-large[^"]*?)"([^>]*)>/g,
          (match) => {
            const styled = this.applyQuillInlineStyle(match, 'font-size:1.4em;');
            return this.removeClass(styled, 'ql-size-large');
          })
        .replace(/<(\w+)([^>]*?)class="([^"]*?ql-size-huge[^"]*?)"([^>]*)>/g,
          (match) => {
            const styled = this.applyQuillInlineStyle(match, 'font-size:2em;');
            return this.removeClass(styled, 'ql-size-huge');
          });
    },
    convertQuillAlign(text) {
      return text
        .replace(/<(\w+)([^>]*?)class="([^"]*?ql-align-center[^"]*?)"([^>]*)>/g,
          (match) => {
            const styled = this.applyQuillInlineStyle(match, 'text-align:center;');
            return this.removeClass(styled, 'ql-align-center');
          })
        .replace(/<(\w+)([^>]*?)class="([^"]*?ql-align-right[^"]*?)"([^>]*)>/g,
          (match) => {
            const styled = this.applyQuillInlineStyle(match, 'text-align:right;');
            return this.removeClass(styled, 'ql-align-right');
          })
        .replace(/<(\w+)([^>]*?)class="([^"]*?ql-align-justify[^"]*?)"([^>]*)>/g,
          (match) => {
            const styled = this.applyQuillInlineStyle(match, 'text-align:justify;');
            return this.removeClass(styled, 'ql-align-justify');
          });
    },
    clearEditElement() {
      if (Object.values(this.selectedElement).length > 0) {
        delete this.selectedElement.status;
        const element = this.active_template.body.data[this.selectedElement.idx_layout].content[`container_${this.selectedElement.idx_column + 1}`];
        this.$delete(element[this.selectedElement.idx_element], 'status');
      }
    },
    onInputMaxSizeImage(key) {
      const val = this.selectedElement[key];
      if (val === '' || val === null) return;
      if (val > this.selectedElement.max_size) this.selectedElement[key] = this.selectedElement.max_size;
      if (val < 1) this.selectedElement[key] = 1;
      this.onChangeSettings();
    },
  },
};
</script>
<style>
.wysiwyg-editor {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}

.wysiwyg-editor .ql-container {
  height: 200px !important;
}

.wysiwyg-editor .ql-editor {
  overflow-x: auto !important;
  white-space: pre-wrap !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
}

.layout-box {
  padding: 10px;
  width: 100%;
  min-height: 80px;
  display: flex;
}

.fixed-panel {
  width: 265px;
  min-width: 265px;
  max-width: 265px;
}

.fixed-panel .el-collapse-item:first-of-type .el-collapse-item__header {
  border-top: none !important;
}

.panel-elements,
.panel-layout {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 630px;
  height: 100%;
  padding-right: 8px;
}

.scroll-wrapper {
  max-height: 780px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 12px;
}

.scroll-wrapper::-webkit-scrollbar {
  width: 6px;
}

.scroll-wrapper::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
}

.panel-column {
  margin-top: 10px;
  width: 170px;
  cursor: pointer;
}

.panel-column:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  border-color: transparent;
}

.sub-panel-column {
  width: 100%;
  padding: 10px;
  background-color: #fafafa;
}

.sub-panel-column:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  border-color: transparent;
}

.inner-panel-column {
  width: 100%;
  padding: 10px;
  border: 1px solid gray;
  background-color: white;
  border-style: dashed;
}

.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  transition: 0.2s ease;
  cursor: pointer;
}

.icon-wrapper:hover {
  background-color: #e6f4f2;
  border-radius: 10px;
  opacity: 0.7;
}

.icon-panel-selected {
  border-radius: 10px;
  background: #e6f4f2;
  color: #329b90;
}

.subpanel-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  font-size: 40px;
  transition: 0.2s ease;
  cursor: pointer;
  padding: 2px;
  background-color: #fafafa;
}

.subpanel-icon:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  border-color: transparent;
}

/* .fade-enter-active {
  transition: top 0.5s ease-in;
}
.fade-leave-active {
  transition: all 0.5s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
  transform: translateY(30px);
  opacity: 0;
} */

.screen {
  text-align: left;
}
.screen-container {
  height: 100%;
}

/* Status Bar */

.status-bar {
  height: 25px;
  background: #004e45;
  color: #fff;
  font-size: 14px;
  padding: 0 8px;
}

.status-bar:after {
  content: "";
  display: table;
  clear: both;
}

.status-bar div {
  float: right;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  margin: 0 0 0 8px;
  font-weight: 600;
}

/* Chat */

.chat {
  height: calc(100% - 69px);
}

.chat-container {
  height: 100%;
}

/* User Bar */

.user-bar {
  height: 55px;
  background: #005e54;
  color: #fff;
  padding: 0 8px;
  font-size: 24px;
  position: relative;
  z-index: 1;
}

.user-bar:after {
  content: "";
  display: table;
  clear: both;
}

.user-bar div {
  float: left;
  transform: translateY(-50%);
  position: relative;
  top: 50%;
}

.user-bar .actions {
  float: right;
  margin: 0 0 0 20px;
}

.user-bar .actions.more {
  margin: 0 12px 0 32px;
}

.user-bar .actions.attachment {
  margin: 0 0 0 30px;
}

.user-bar .actions.attachment i {
  display: block;
  transform: rotate(-45deg);
}

.user-bar .avatar {
  margin: 0 0 0 5px;
  width: 36px;
  height: 36px;
}

.user-bar .avatar img {
  border-radius: 50%;
  /* box-shadow: 0 1px 0 rgba(255, 255, 255, 0.1); */
  display: block;
  width: 100%;
}

.user-bar .name {
  font-size: 17px;
  font-weight: 600;
  text-overflow: ellipsis;
  letter-spacing: 0.3px;
  margin: 0 0 0 8px;
  overflow: hidden;
  white-space: nowrap;
  width: 110px;
}

.user-bar .status {
  display: block;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0;
}

/* Conversation */

.conversation {
  height: calc(100% - 12px);
  position: relative;
  background: #efe7dd url("https://cloud.githubusercontent.com/assets/398893/15136779/4e765036-1639-11e6-9201-67e728e86f39.jpg") repeat;
  z-index: 0;
}

.conversation ::-webkit-scrollbar {
  transition: all .5s;
  width: 5px;
  height: 1px;
  z-index: 10;
}

.conversation ::-webkit-scrollbar-track {
  background: transparent;
}

.conversation ::-webkit-scrollbar-thumb {
  background: #b3ada7;
}

.conversation .conversation-container {
  height: calc(100% - 68px);
  /* box-shadow: inset 0 10px 10px -10px #000000; */
  overflow-x: hidden;
  padding: 0 16px;
  margin-bottom: 5px;
}

.conversation .conversation-container:after {
  content: "";
  display: table;
  clear: both;
}

/* Messages */

.preview-message {
  color: #000;
  clear: both;
  line-height: 18px;
  font-size: 12px;
  padding: 8px;
  position: relative;
  margin: 8px 0;
  /* max-width: 85%; */
  word-wrap: break-word;
  /* z-index: -1; */
}

.preview-message-carousel {
  color: #000;
  clear: both;
  line-height: 18px;
  font-size: 12px;
  padding: 8px;
  position: relative;
  margin: 8px 0;
  /* max-width: 85%; */
  word-wrap: break-word;
  /* z-index: -1; */
}

.preview-message-carousel {
  color: #000;
  clear: both;
  line-height: 18px;
  font-size: 12px;
  padding: 8px;
  position: relative;
  margin: 8px 0;
  /* max-width: 85%; */
  word-wrap: break-word;
  z-index: -1;
}

.preview-message:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-style: solid;
}

.button-area {
  color: #000;
  clear: both;
  line-height: 18px;
  font-size: 12px;
  padding: 8px 0px;
  position: relative;
  word-wrap: break-word;
  z-index: -1;
  border-radius: 5px;
  float: left;
}

.reply-button {
  color: #5591EC;
  clear: both;
  line-height: 18px;
  font-size: 12px;
  padding: 8px;
  position: relative;
  word-wrap: break-word;
  z-index: -1;
  background: #fff;
  border-radius: 5px;
  float: left;
  text-align: center;
}

.cta-area {
  border-top: 1px solid #dadde1;
  /* margin: 0 7px 0 9px; */
  margin-top: 8px;
  float: right;
  background: #fff;
}

.cta-button {
  color: #00a5f4;
  font-size: 12px;
  height: 24px;
  line-height: 20px;
  padding: 0 16px;
  white-space: pre-wrap;
  text-align: center;
  justify-content: center;
  flex-direction: row;
  display: flex;
  word-wrap: break-word;
  margin-top: 5%;
}

.header-media-area {
  padding: 3px 3px 0 3px;
}

.header-media-content {
  background-color: #ccd0d5;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 80px 80px;
  border-radius: 4px;
  box-sizing: border-box;
}

.header-media-content::after {
  content: '';
  display: block;
  padding-top: calc(100% * (1 / 1.91));
}

.header-media-image {
  background-image: url('https://media.wappin.chat/template-header-image.png');
}

.header-media-filled {
  background-color: #ccd0d5;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: auto 100%;
  border-radius: 4px;
  box-sizing: border-box;
  /* width: 240px; */
}

.header-media-filled::after {
  content: '';
  display: block;
  padding-top: calc(100% * (1 / 1.91));
}

.metadata {
  display: inline-block;
  float: right;
  padding: 0 0 0 7px;
  position: relative;
  bottom: -4px;
}

.metadata .time {
  color: rgba(0, 0, 0, .45);
  font-size: 11px;
  display: inline-block;
}

.metadata .tick {
  display: inline-block;
  margin-left: 2px;
  position: relative;
  top: 4px;
  height: 16px;
  width: 16px;
}

.metadata .tick svg {
  position: absolute;
  transition: .5s ease-in-out;
}

.metadata .tick svg:first-child {
  -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
  -webkit-transform: perspective(800px) rotateY(180deg);
          transform: perspective(800px) rotateY(180deg);
}

.metadata .tick svg:last-child {
  -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
  -webkit-transform: perspective(800px) rotateY(0deg);
          transform: perspective(800px) rotateY(0deg);
}

.metadata .tick-animation svg:first-child {
  -webkit-transform: perspective(800px) rotateY(0);
          transform: perspective(800px) rotateY(0);
}

.metadata .tick-animation svg:last-child {
  -webkit-transform: perspective(800px) rotateY(-179.9deg);
          transform: perspective(800px) rotateY(-179.9deg);
}

.preview-message:first-child {
  margin: 16px 0 8px;
}

.preview-message.received {
  background: #fff;
  border-radius: 0px 5px 5px 5px;
  float: left;
}

.preview-message.received .metadata {
  padding: 0 0 0 16px;
}

.preview-message.received:after {
  border-width: 0px 10px 10px 0;
  border-color: transparent #fff transparent transparent;
  top: 0;
  left: -10px;
}

.preview-message.received.carousel-message {
  border-radius: 5px;
}
.preview-message.received.carousel-message img {
  width: 100%;
  height: auto;
  border-radius: 5px;
}

.preview-message.received.carousel-message:after {
  /* border-width: 0px 10px 10px 0;
  border-color: transparent #fff transparent transparent;
  top: 0; */
  left: 10px;
}

.preview-message.sent {
  background: #e1ffc7;
  border-radius: 5px 0px 5px 5px;
  float: right;
}

.preview-message.sent:after {
  border-width: 0px 0 10px 10px;
  border-color: transparent transparent transparent #e1ffc7;
  top: 0;
  right: -10px;
}

.preview-message-carousel:first-child {
  margin: 16px 0 8px;
}

.preview-message-carousel.received {
  background: #fff;
  border-radius: 5px 5px 5px 5px;
  float: left;
}

.preview-message-carousel.received .metadata {
  padding: 0 0 0 16px;
}

/* .preview-message-carousel.received:after {
  border-width: 0px 10px 10px 0;
  border-color: transparent #fff transparent transparent;
  top: 0;
  right: 10px;
  content: '';
} */

.preview-message-carousel.received.carousel-message {
  border-radius: 5px;
}
.preview-message-carousel.received.carousel-message img {
  width: 100%;
  height: auto;
  border-radius: 5px;
}

.preview-message-carousel.received.carousel-message:after {
  /* border-width: 0px 10px 10px 0;
  border-color: transparent #fff transparent transparent;
  top: 0; */
  left: 10px;
}

.preview-message-carousel.sent {
  background: #e1ffc7;
  border-radius: 5px 5px 5px 5px;
  float: right;
}

.preview-message-carousel:first-child {
  margin: 16px 0 8px;
}

.preview-message-carousel.received {
  background: #fff;
  border-radius: 5px 5px 5px 5px;
  float: left;
}

.preview-message-carousel.received .metadata {
  padding: 0 0 0 16px;
}

/* .preview-message-carousel.received:after {
  border-width: 0px 10px 10px 0;
  border-color: transparent #fff transparent transparent;
  top: 0;
  right: 10px;
  content: '';
} */

.preview-message-carousel.received.carousel-message {
  border-radius: 5px;
}
.preview-message-carousel.received.carousel-message img {
  width: 100%;
  height: auto;
  border-radius: 5px;
}

.preview-message-carousel.received.carousel-message:after {
  /* border-width: 0px 10px 10px 0;
  border-color: transparent #fff transparent transparent;
  top: 0; */
  left: 10px;
}

.preview-message-carousel.sent {
  background: #e1ffc7;
  border-radius: 5px 5px 5px 5px;
  float: right;
}

.preview-button {
  color: #000;
  clear: both;
  line-height: 18px;
  font-size: 12px;
  padding: 8px;
  margin-bottom: 10px;
  /* position: absolute; */
  /* border: solid 1px #97704F; */
  /* margin: 0px; */
  /* margin: 8px 0; */
  word-wrap: break-word;
  /* z-index: -1; */
}

.preview-button.bottom {
  bottom: 0;
  background: #fff;
  border-radius: 5px 5px 5px 5px;
  float: left;
}
/* Compose */

.conversation-compose {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  overflow: hidden;
  height: 50px;
  width: 100%;
  z-index: 2;
}

.conversation-compose div,
.conversation-compose input {
  background: #fff;
  height: 100%;
}

.conversation-compose .emoji {
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 5px 0 0 5px;
  flex: 0 0 auto;
  margin-left: 8px;
  width: 48px;
}

.conversation-compose .input-msg {
  border: 0;
  flex: 1 1 auto;
  font-size: 16px;
  margin: 0;
  outline: none;
  min-width: 50px;
}

.conversation-compose .photo {
  flex: 0 0 auto;
  border-radius: 0 0 5px 0;
  text-align: center;
  position: relative;
  width: 48px;
}

.conversation-compose .photo:after {
  border-width: 0px 0 10px 10px;
  border-color: transparent transparent transparent #fff;
  border-style: solid;
  position: absolute;
  width: 0;
  height: 0;
  content: "";
  top: 0;
  right: -10px;
}

.conversation-compose .photo i {
  display: block;
  color: #7d8488;
  font-size: 24px;
  transform: translate(-50%, -50%);
  position: relative;
  top: 50%;
  left: 50%;
}

.conversation-compose .send {
  background: transparent;
  border: 0;
  cursor: pointer;
  flex: 0 0 auto;
  margin-left: 8px;
  margin-right: 8px;
  padding: 0;
  position: relative;
  outline: none;
}

.conversation-compose .send .circle {
  background: #008a7c;
  border-radius: 50%;
  color: #fff;
  position: relative;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.conversation-compose .send .circle i {
  font-size: 24px;
  margin-left: 5px;
}

.preview-footer {
  font-size: 11px;
  color: rgba(0, 0, 0, .45);
  word-wrap: break-word;
  white-space: pre-wrap;
}

.preview-body {
  font-size: 12px;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.row-button {
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: row;
  display: flex;
}

.col-button {
  background-color: #fff;
  border-radius: 7.5px;
  box-shadow: 0 1px 0.5px rgb(0 0 0 / 15%);
  box-sizing: border-box;
  flex-grow: 1;
  margin: 2px 0 0 2px;
  min-width: calc(50% - 2px);
  color: #00a5f4;
  font-size: 14px;
  height: 34px;
  line-height: 20px;
  padding: 0 16px;
  white-space: pre-wrap;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  display: flex;
}

.swiper-slide {
  display: flex !important;
  justify-content: flex-start !important;
  flex-direction: column !important;
  min-width: 204px;
}
.swiper-wrapper {
  display: flex;
  width: 100px !important;
}
.swiper-container {
  height: 450px !important;
  width: 100% !important;
}

.template-img {
  height: 150 !important;
  width: 150 !important;
  padding: 30px !important;
  background-color: #ccd0d5 !important;
  background-position: center center !important;
  background-repeat: no-repeat !important;
  background-size: 80px 80px !important;
  border-radius: 4px !important;
  box-sizing: border-box !important;
}

.ql-editor ol {
  list-style-type: decimal !important;
  padding-left: 24px !important;
}

.ql-editor ul {
  list-style-type: disc !important;
  padding-left: 24px !important;
}

.ql-editor li {
  list-style: inherit !important;
}

/* Small Screens */
@media (max-width: 768px) {
  .marvel-device.nexus5 {
    border-radius: 0;
    flex: none;
    padding: 0;
    max-width: none;
    overflow: hidden;
    height: 100%;
    width: 100%;
  }

  .marvel-device > .screen .chat {
    visibility: visible;
  }

  .marvel-device {
    visibility: hidden;
  }

  .marvel-device .status-bar {
    display: none;
  }

  .screen-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .conversation {
    height: calc(100vh - 55px);
  }
  .conversation .conversation-container {
    height: calc(100vh - 120px);
  }
}
</style>
